<template>
  <v-app id="inspire">
    <Header type="search"/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>
          <Menu/>
          <v-container class="col-10">
            <v-row>
              <v-col
                  class="page-top d-flex justify-space-between"
                  cols="12"
              >
                <div>
                  <div class="page-title">Расписание</div>
                  <div class="breadcrumb">Расписание</div>
                 
                </div>
              </v-col>
              <v-col cols="12" v-if="!isLoading">
                <v-sheet
                    max-height="80px"
                    rounded="lg"
                    class="d-flex justify-space-between align-center card"
                >
                  <v-tabs
                      centered
                      id="horizontal_tabs"
                      v-model="schedule_tab"
                      class="d-flex align-center schedule__tab"
                  >
                    <v-tab
                        v-for="item in schedules"
                        :key="item.tab"
                        ref="selectedTab"
                        class="ml-4"
                    >
                      {{ item.tab }}
                    </v-tab>
                  </v-tabs>
                  <v-btn-toggle
                      v-if="schedule_tab === 1"
                      v-model="toggle_category"
                      mandatory
                      class="ml-5 rounded-lg"
                  >
                    <v-btn>
                      Сотрудники
                    </v-btn>
                    <v-btn>
                      Помещение
                    </v-btn>
                    <!-- <v-btn v-if="type === 'week' && schedule_tab === 1">
                      Неделя
                    </v-btn> -->
                  </v-btn-toggle>
                  <v-btn-toggle
                      v-if="schedule_tab === 2 || schedule_tab === 0"
                      v-model="toggle_category_all"
                      mandatory
                      class="ml-5 rounded-lg"
                  >
                    <v-btn>
                      Сотрудники
                    </v-btn>
                    <v-btn>
                      Помещение
                    </v-btn>
                  </v-btn-toggle>
                </v-sheet>
              </v-col>
              <v-skeleton-loader
                        v-else
                        type="list-item-two-line"
                        style="width:100%;"
                    >
                    </v-skeleton-loader>
              <v-col >
                <v-tabs-items v-model="schedule_tab">
                  <v-tab-item>
                    <v-sheet class="rounded-lg">

                      <v-card-title
                          v-if="!isLoading"
                          class="d-flex justify-space-between align-center"
                      >
                        <div class="calendar-options d-flex align-center">
                          <v-btn-toggle
                              v-model="toggle_date"
                              mandatory
                              class="ml-5 rounded-lg"
                          >
                            <v-btn @click="changeDay">
                              День
                            </v-btn>
                            <v-btn @click="changeWeek">
                              Неделя
                            </v-btn>
                          </v-btn-toggle>
                          <v-btn-toggle
                              v-model="toggle_week"
                              class="ml-5 rounded-lg"
                          >
                            <v-btn @click="prev" style="padding: 0 !important; min-width: 38px !important;">
                              <v-icon
                              >
                                mdi-chevron-left
                              </v-icon>
                            </v-btn>
                            <v-btn @click="next" style="padding: 0 !important; min-width: 38px !important;">
                              <v-icon
                              >
                                mdi-chevron-right
                              </v-icon>
                            </v-btn>
                          </v-btn-toggle>
                          <VueDatePicker
                              no-title
                              no-header
                              disabled
                              color="#629f34"
                              class="ml-4"
                              style="flex: none !important;"
                              v-if="start && end && !dialogDate"
                          >
                            <template #activator>
                              <button
                                  class="button custom__date-button"
                                  ref="activator"
                                  type="button"
                              >
                                <v-icon
                                    dark
                                    small
                                    class="mr-2"
                                >
                                  mdi-calendar-blank-outline
                                </v-icon>  {{ start.day === end.day ? start.day : start.day + '-' + end.day }} {{ start.month === end.month ? months[start.month - 1] : months[start.month - 1] + ' - ' + months[end.month - 1]}}
                              </button>
                            </template>
                          </VueDatePicker>
                          <VueDatePicker
                              no-title
                              no-header
                              v-model="dateTable"
                              @onChange="typeToDate(dateTable)"
                              color="#629f34"
                              class="ml-4"
                              style="flex: none !important;"
                              v-if="dialogDate"
                          >
                            <template #activator="{ date }">
                              <button
                                  class="button custom__date-button"
                                  ref="activator"
                                  type="button"
                              >
                                <v-icon
                                    dark
                                    small
                                    class="mr-2"
                                >
                                  mdi-calendar-blank-outline
                                </v-icon> {{ date }}
                              </button>
                            </template>
                          </VueDatePicker>
                          <v-btn-toggle
                              v-model="toggle_day"
                              mandatory
                              class="ml-5 rounded-lg"
                          >
                            <v-btn>
                              Утро
                            </v-btn>
                            <v-btn>
                              Вечер
                            </v-btn>
                            <v-btn>
                              Весь день
                            </v-btn>
                          </v-btn-toggle>
                        </div>
                        <div class="filter-schedule">
                          <v-btn
                              dark
                              class="filter-button"
                              @click="dialogFiler = !dialogFiler, events_def = events, clientEvents_def = clientEvents, allEvents_def = allEvents, events_def_def = events"
                          >
                            <img
                                class="mr-1"
                                src="/playground_assets/mediumfilter.svg"
                            >
                            Фильтр
                          </v-btn>
                        </div>
                      </v-card-title>
                      <v-skeleton-loader
                        v-else
                        type="list-item-two-line"
                        style="width:100%;"
                    >
                    </v-skeleton-loader>

                      <v-card-text
                          v-show="dialogFiler"
                      >
                        <v-form
                            ref="groupFilterForm"
                            v-model="valid"
                        >
                          <v-container>
                            <v-row>
                              <v-col
                                  cols="12"
                                  sm="4"
                                  md="4"
                              >
                                <label>Сотрудники</label>
                                <v-select
                                    @input="collectData"
                                    class="rounded-lg custom__select"
                                    v-model="groupLessonFilter.specialist"
                                    :items="events_def"
                                    item-value="specialist_id"
                                    item-text="specialist_name"
                                    ref="selectedEl1"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                    label="Выбрать"
                                    append-icon="mdi-chevron-down"
                                    outlined
                                    dense
                                    color="#629F33"
                                    item-color="#629F33"
                                    clearable
                                    multiple
                                    style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                >
                                  <template v-slot:selection="data">
                                    <span
                                        v-if="groupLessonFilter.specialist.length === 1"
                                        v-bind="data.attrs"
                                    >
                                      {{ data.item.specialist_name}}
                                    </span>
                                    <div v-else-if="data.index === 0">
                                      Выбрано {{ groupLessonFilter.specialist.length }} сотрудников
                                    </div>
                                  </template>
                                </v-select>
                              </v-col>
                              <v-col
                                  cols="12"
                                  sm="4"
                                  md="4"
                              >
                                <label>Должность</label>

                                <!-- {{groupLessonFilter}} -->
                                <v-select
                                    @input="collectData"
                                    class="rounded-lg custom__select"
                                    v-model="groupLessonFilter.position"
                                    :items="events_def_def"
                                    item-value="post_id"
                                    item-text="post_name"
                                    ref="selectedEl3"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                    label="Выбрать"
                                    append-icon="mdi-chevron-down"
                                    outlined
                                    dense
                                    color="#629F33"
                                    style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                ></v-select>
                              </v-col>
                              <v-col
                                  cols="12"
                                  sm="4"
                                  md="4"
                              >
                                <label>Помещение</label>

                                <v-select
                                    @input="collectData"
                                    class="rounded-lg custom__select"
                                    v-model="groupLessonFilter.room"
                                    :items="events_def_def"
                                    item-value="room_id"
                                    item-text="room_name"
                                    ref="selectedEl4"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                    label="Выбрать"
                                    append-icon="mdi-chevron-down"
                                    outlined
                                    dense
                                    color="#629F33"
                                    style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                ></v-select>
                              </v-col>
                              <v-col
                                  cols="12"
                                  sm="4"
                                  md="4"
                                  class="mt-3"
                              >
                                <label>Сегмент сотрудников</label>
                                <v-autocomplete
                                    @input="collectData"
                                    class="rounded-lg custom__select"
                                    :items="listStaffSegments ? listStaffSegments.schedule.data : []"
                                    item-value="id"
                                    item-text="name"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                    label="Выбрать"
                                    append-icon="mdi-chevron-down"
                                    no-data-text="Результатов не найдено"
                                    v-model="groupLessonFilter.select_segment"
                                    outlined
                                    dense
                                    color="#629F33"
                                    style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                >
                                </v-autocomplete>
                              </v-col>
                              <v-col
                                  cols="12"
                                  sm="4"
                                  md="4"
                                  class="mt-3"
                              >
                                <label>Услуга</label>
                                <v-select
                                    @input="collectData"
                                    class="rounded-lg custom__select"
                                    v-model="groupLessonFilter.service"
                                    :items="events_def"
                                    ref="selectedEl6"
                                    item-text="name"
                                    item-value="service_id"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                    label="Выбрать"
                                    append-icon="mdi-chevron-down"
                                    outlined
                                    dense
                                    color="#629F33"
                                    style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                ></v-select>
                              </v-col>
                              <v-col
                                  cols="12"
                                  sm="4"
                                  md="4"
                                  class="mt-3"
                              >
                                <label>Статус</label>
                                <v-select
                                    @input="collectData"
                                    class="rounded-lg custom__select"
                                    v-model="groupLessonFilter.status"
                                    :items="statusTypes"
                                    ref="selectedEl2"
                                    item-text="type_name"
                                    item-value="type_id"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                    label="Выбрать"
                                    append-icon="mdi-chevron-down"
                                    outlined
                                    dense
                                    color="#629F33"
                                    style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                ></v-select>
                              </v-col>
                              <v-card-actions class="mt-4">
                                <template v-if="!dialogButton">
                                  <button
                                      class="button custom__button mt-5"
                                      type="button"
                                  >
                                    Применить
                                  </button>
                                </template>
                                <template v-else>
                                  <button
                                      class="button custom__button mt-5"
                                      type="button"
                                      style="background-color: #A13453 !important;color: #fff !important;"
                                      @click="filterEvents(groupLessonFilter)"
                                  >
                                    Применить
                                  </button>
                                  <button
                                      class="button custom__button mt-5 ml-3"
                                      type="button"
                                      style="background-color: #D53025 !important;color: #fff !important; width: auto !important; padding: 5px 20px;"
                                      @click="clearData"
                                  >
                                    Сбросить фильтр
                                  </button>
                                </template>
                              </v-card-actions>
                            </v-row>
                          </v-container>
                        </v-form>
                      </v-card-text>
                      <!-- <v-calendar
                          v-if="!dialogDate"
                          ref="weeklyCalendar"
                          v-model="focus"
                          locale="ru"
                          :type="type"
                          :weekdays="[1,2,3,4,5,6,0]"
                          :short-intervals="false"
                          :interval-count="getIntervalCount(toggle_day)"
                          :interval-height="82"
                          :first-time="toggle_day === 0 || toggle_day === 2 ? '07:00' : '14:00'"
                          :events="events"
                          event-overlap-mode="column"
                          class="custom__calendar"
                          @change="updateRange"
                          @mousedown:time="startTimeGroup"
                          @mousemove:time="mouseMoveGroup"
                          @mouseup:time="endDragGroup"
                          @mouseleave.native="cancelDragGroup"
                      >
                        <template v-slot:day-label-header>
                          <span></span>
                        </template>
                        <template v-slot:event="{ eventParsed }">
                          <router-link :to="{ name: 'Lesson', params: { appointment_id: eventParsed.input.id} }" style="text-decoration: none">
                            <div style="padding: 10px">
                              <div class="d-flex justify-space-between align-center" v-if="eventParsed.input.status < 2">
                                <div class="event-time">{{ eventParsed.start.time }} - {{ eventParsed.end.time }}</div>
                                <div class="event-count">{{ eventParsed.input.count }}/{{ eventParsed.input.slots }}</div>
                              </div>
             
                              <div class="event-name" v-if="eventParsed.input.status < 2">{{ eventParsed.input.name }}</div>

                              <div class="event-name" v-else>ОТМЕНЕНО</div>

                            </div>
                          </router-link>
                        </template>
                      </v-calendar>
                      <v-calendar
                          v-if="dialogDate"
                          ref="dailyCalendar"
                          locale="en"
                          :start="dateTable"
                          :type="type"
                          :weekdays="[1,2,3,4,5,6,0]"
                          :short-intervals="false"
                          :interval-count="getIntervalCount(toggle_day)"
                          :interval-height="82"
                          :first-time="toggle_day === 0 || toggle_day === 2 ? '07:00' : '14:00'"
                          :events="events"
                          event-overlap-mode="column"
                          class="custom__calendar"
                          @mousedown:time="startTimeGroup"
                          @mousemove:time="mouseMoveGroup"
                          @mouseup:time="endDragGroup"
                          @mouseleave.native="cancelDragGroup"
                      >
                        <template v-slot:day-label-header>
                          <span></span>
                        </template>
                        <template v-slot:event="{ eventParsed }">
                          <router-link :to="{ name: 'Lesson', params: { appointment_id: eventParsed.input.id} }" style="text-decoration: none">
                            <div style="padding: 10px">
                              <div class="d-flex justify-space-between align-center" v-if="eventParsed.input.status < 2">
                                <div class="event-time">{{ eventParsed.start.time }} - {{ eventParsed.end.time }}</div>
                                <div class="event-count">{{ eventParsed.input.count }}/{{ eventParsed.input.slots }}</div>
                              </div>
                              <div class="event-name" v-if="eventParsed.input.status < 2">{{ eventParsed.input.name }}</div>

                              <div class="event-name" v-else>ОТМЕНЕНО</div>
                            </div>
                          </router-link>
                        </template>
                      </v-calendar> -->

                       <v-calendar
                       v-if="dialogDate"
                          ref="dailyCalendar"
                          locale="ru"
                          type="category"
                          :start="dateTable"
                          :categories="categories"
                          :category-show-all="true"
                          category-text="text"
                          :events="events"
                          :short-intervals="false"
                          :interval-count="getIntervalCount(toggle_day)"
                          :interval-height="82"
                          @change="updateRange"
                          :first-time="toggle_day === 0 || toggle_day === 2 ? '07:00' : '14:00'"
                          :class="categories.length <= 6 ? 'custom__client-calendar ccustom_x' : 'show__all-category custom__client-calendar ccustom_x'"
                          @mouseup:time-category="endDragGroup"
                      >
                        <template v-slot:day-label-header>
                          <span></span>
                        </template>
                        <template v-slot:event="{ eventParsed }">
                          <router-link :to="{ name: 'Lesson', params: { appointment_id: eventParsed.input.id} }" style="text-decoration: none">
                            <div style="padding: 10px" v-if="eventParsed.input.color !== '#f0f0f0'">
                              <div class="d-flex justify-space-between align-center" v-if="eventParsed.input.status < 2">
                                <div class="event-time">{{ eventParsed.start.time }} - {{ eventParsed.end.time }}</div>
                                <div class="event-count" >{{ eventParsed.input.count }}/{{ eventParsed.input.slots }}</div>
                              </div>
                              <div class="event-name" v-if="eventParsed.input.status < 2">{{ eventParsed.input.name }}</div>

                              <div class="event-name" v-else>ОТМЕНЕНО</div>
                            </div>
                          </router-link>
                        </template>
                        <template v-slot:interval="{ category, date, time}">
                          <div v-for="duty in dutyEvents" :key="duty.id"  class='gg-11'>
                            <div v-for="dutyTime in duty.schedule_duty" :key="duty.id+dutyTime.startdate.date+dutyTime.startdate.time">
                              <div v-if="duty.id === category.value && dutyGrid(date, time, dutyTime)" class="duty-interval"></div>
                            </div>
                          </div>
                        </template>
                      </v-calendar>

                      <v-calendar
                          v-else-if="(toggle_category === 1) && !dialogDate"
                          ref="dailyCalendar"
                          locale="ru"
                          type="category"
                          :start="dateTable"
                          :categories="categories"
                          :category-show-all="true"
                          category-text="text"
                          :events="events"
                          :short-intervals="false"
                          :interval-count="getIntervalCount(toggle_day)"
                          :interval-height="82"
                          @change="updateRange"
                          :first-time="toggle_day === 0 || toggle_day === 2 ? '07:00' : '14:00'"
                          :class="categories.length <= 6 ? 'custom__client-calendar ccustom_x' : 'show__all-category ustom__client-calendar ccustom_x'"
                          @mouseup:time-category="endDragGroup"
                      >
                        <template v-slot:day-label-header>
                          <span></span>
                        </template>
                        <template v-slot:event="{ eventParsed }">
                          <router-link :to="{ name: 'Lesson', params: { appointment_id: eventParsed.input.id} }" style="text-decoration: none">
                            <div style="padding: 10px" v-if="eventParsed.input.color !== '#f0f0f0'">
                              <div class="d-flex justify-space-between align-center" v-if="eventParsed.input.status < 2">
                                <div class="event-time">{{ eventParsed.start.time }} - {{ eventParsed.end.time }}</div>
                                <div class="event-count" >{{ eventParsed.input.count }}/{{ eventParsed.input.slots }}</div>
                              </div>
                              <div class="event-name" v-if="eventParsed.input.status < 2">{{ eventParsed.input.name }}</div>

                              <div class="event-name" v-else>ОТМЕНЕНО</div>
                            </div>
                          </router-link>
                        </template>
                        <template v-slot:interval="{ category, date, time}">
                          <div v-for="duty in dutyEvents" :key="duty.id"  class='gg-11'>
                            <div v-for="dutyTime in duty.schedule_duty" :key="duty.id+dutyTime.startdate.date+dutyTime.startdate.time">
                              <div v-if="duty.id === category.value && dutyGrid(date, time, dutyTime)" class="duty-interval"></div>
                            </div>
                          </div>
                        </template>
                      </v-calendar>

              

                      <v-calendar
                          v-else-if="!dialogDate"
                          ref="weeklyCalendar"
                          v-model="focus"
                          locale="ru"
                          :type="type"
                          :weekdays="[1,2,3,4,5,6,0]"
                          :short-intervals="false"
                          :interval-count="getIntervalCount(toggle_day)"
                          :interval-height="82"
                          :first-time="toggle_day === 0 || toggle_day === 2 ? '07:00' : '14:00'"
                          :events="events"
                          event-overlap-mode="column"
                          class="custom__calendar"
                          @change="updateRange"
                          @mouseup:time-category="endDragGroup"
                      >
                        <template v-slot:day-label-header>
                          <span></span>
                        </template>
                        <template v-slot:event="{ eventParsed }">
                          <router-link :to="{ name: 'Lesson', params: { appointment_id: eventParsed.input.id} }" style="text-decoration: none">
                            <div style="padding: 10px" v-if="eventParsed.input.color !== '#f0f0f0'">
                              <div class="d-flex justify-space-between align-center" v-if="eventParsed.input.status < 2">
                                <div class="event-time">{{ eventParsed.start.time }} - {{ eventParsed.end.time }}</div>
                                <div class="event-count" >{{ eventParsed.input.count }}/{{ eventParsed.input.slots }}</div>
                              </div>
                              <div class="event-name" v-if="eventParsed.input.status < 2">{{ eventParsed.input.name }}</div>

                              <div class="event-name" v-else>ОТМЕНЕНО</div>
                            </div>
                          </router-link>
                        </template>
                        <template v-slot:interval="{ date, time}">
                          <div v-for="duty in dutyEvents" :key="duty.id">
                            <div v-for="dutyTime in duty.schedule_duty" :key="duty.id+dutyTime.startdate.date+dutyTime.startdate.time">
                              <div v-if="duty.name === indivLessonFilter.specialist[0] && dutyGrid(date, time, dutyTime)" class="duty-interval"></div>
                            </div>
                          </div>
                        </template>
                      </v-calendar>

                    </v-sheet>
                  </v-tab-item>
                  <v-tab-item>
                    <v-sheet class="rounded-lg">
                      <v-card-title
                          class="d-flex justify-space-between align-center"
                      >
                        <div class="calendar-options d-flex align-center">
                          <v-btn-toggle
                              v-model="toggle_date"
                              mandatory
                              class="ml-5 rounded-lg"
                          >
                            <v-btn @click="changeDay">
                              День
                            </v-btn>
                            <v-btn @click="changeWeek">
                              Неделя
                            </v-btn>
                          </v-btn-toggle>
                          <v-btn-toggle
                              v-model="toggle_week"
                              class="ml-5 rounded-lg"
                          >
                            <v-btn @click="prev" style="padding: 0 !important; min-width: 38px !important;">
                              <v-icon
                              >
                                mdi-chevron-left
                              </v-icon>
                            </v-btn>
                            <v-btn @click="next" style="padding: 0 !important; min-width: 38px !important;">
                              <v-icon
                              >
                                mdi-chevron-right
                              </v-icon>
                            </v-btn>
                          </v-btn-toggle>
                          <VueDatePicker
                              no-title
                              no-header
                              disabled
                              color="#629f34"
                              class="ml-4"
                              style="flex: none !important;"
                              v-if="start && end && !dialogDate"
                          >
                            <template #activator>
                              <button
                                  class="button custom__date-button"
                                  ref="activator"
                                  type="button"
                              >
                                <v-icon
                                    dark
                                    small
                                    class="mr-2"
                                >
                                  mdi-calendar-blank-outline
                                </v-icon>  {{ start.day === end.day ? start.day : start.day + '-' + end.day }} {{ start.month === end.month ? months[start.month - 1] : months[start.month - 1] + ' - ' + months[end.month - 1]}}
                              </button>
                            </template>
                          </VueDatePicker>
                          <VueDatePicker
                              no-title
                              no-header
                              v-model="dateTable"
                              @onChange="typeToDate(dateTable)"
                              color="#629f34"
                              class="ml-4"
                              style="flex: none !important;"
                              v-if="dialogDate"
                          >
                            <template #activator="{ date }">
                              <button
                                  class="button custom__date-button"
                                  ref="activator"
                                  type="button"
                              >
                                <v-icon
                                    dark
                                    small
                                    class="mr-2"
                                >
                                  mdi-calendar-blank-outline
                                </v-icon> {{ date }}
                              </button>
                            </template>
                          </VueDatePicker>
                          <v-btn-toggle
                              v-model="toggle_day"
                              mandatory
                              class="ml-5 rounded-lg"
                          >
                            <v-btn>
                              Утро
                            </v-btn>
                            <v-btn>
                              Вечер
                            </v-btn>
                            <v-btn>
                              Весь день
                            </v-btn>
                          </v-btn-toggle>
                        </div>
                        <div class="filter-schedule">
                          <v-btn
                              dark
                              class="filter-button"
                              @click="dialogFiler_indiv = !dialogFiler_indiv, events_def = events, clientEvents_def = clientEvents, allEvents_def = allEvents"
                          >
                            <img
                                class="mr-1"
                                src="/playground_assets/mediumfilter.svg"
                            >
                            Фильтр
                          </v-btn>
                        </div>
                      </v-card-title>
                      <v-card-text
                          v-show="dialogFiler_indiv"
                      >
                        <v-form
                            ref="indivFilterForm"
                            v-model="valid_indiv"
                        >
                          <v-container>
                            <v-row>
                              <v-col
                                  cols="12"
                                  sm="4"
                                  md="4"
                              >
                                <label>Сотрудники</label>
                                <v-select
                                    @input="collectData"
                                    class="rounded-lg custom__select"
                                    v-model="indivLessonFilter.specialist"
                                    :items="clientEvents_def"
                                    item-value="specialist_id"
                                    item-text="specialist_name"
                                    ref="selectedEl1"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                    label="Выбрать"
                                    append-icon="mdi-chevron-down"
                                    outlined
                                    dense
                                    color="#629F33"
                                    item-color="#629F33"
                                    clearable
                                    multiple
                                    style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                >
                                  <template v-slot:selection="data">
                                    <span
                                        v-if="indivLessonFilter.specialist.length === 1"
                                        v-bind="data.attrs"
                                    >
                                      {{ data.item.specialist_name }}
                                    </span>
                                    <div v-else-if="data.index === 0">
                                      Выбрано {{ indivLessonFilter.specialist.length }} сотрудников
                                    </div>
                                  </template>
                                </v-select>
                              </v-col>
                              <v-col
                                  cols="12"
                                  sm="4"
                                  md="4"
                              >
                                <label>Должность</label>
                                <v-select
                                    @input="collectData"
                                    class="rounded-lg custom__select"
                                    v-model="indivLessonFilter.position"
                                    :items="clientEvents_def"
                                    item-value="post_id"
                                    item-text="post_name"
                                    ref="selectedEl3"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                    label="Выбрать"
                                    append-icon="mdi-chevron-down"
                                    outlined
                                    dense
                                    color="#629F33"
                                    style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                ></v-select>
                              </v-col>
                              <v-col
                                  cols="12"
                                  sm="4"
                                  md="4"
                              >
                                <label>Помещение</label>

                                <!-- <v-select
                                    @input="collectData"
                                    class="rounded-lg custom__select"
                                    v-model="indivLessonFilter.room"
                                    :items="clientEvents_def"
                                    item-value="room_id"
                                    item-text="room_name"
                                    ref="selectedEl4"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                    label="Выбрать"
                                    append-icon="mdi-chevron-down"
                                    outlined
                                    dense
                                    color="#629F33"
                                    item-color="#629F33"
                                    clearable
                                    multiple
                                    style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                >
                                  <template v-slot:selection="data">
                                    <span
                                        v-if="indivLessonFilter.room.length === 1"
                                        v-bind="data.attrs"
                                    >
                                      {{ data.item.room_name }}
                                    </span>
                                    <div v-else-if="data.index === 0">
                                      Выбрано {{ indivLessonFilter.room.length }} помещении
                                    </div>
                                  </template>
                                </v-select> -->

                                <v-select
                                    @input="collectData"
                                    class="rounded-lg custom__select"
                                    v-model="indivLessonFilter.room"
                                    :items="(indivLessonFilter.room && indivLessonFilter.room.length > 0) ? clientEvents_def : clientEvents"
                                    item-value="room_id"
                                    item-text="room_name"
                                    ref="selectedEl4"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                    label="Выбрать"
                                    append-icon="mdi-chevron-down"
                                    outlined
                                    dense
                                    color="#629F33"
                                    style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                ></v-select>

                              </v-col>
                              <v-col
                                  cols="12"
                                  sm="4"
                                  md="4"
                                  class="mt-3"
                              >
                                <label>Сегмент сотрудников</label>
                                <v-autocomplete
                                    @input="collectData"
                                    class="rounded-lg custom__select"
                                    :items="listStaffSegments ? listStaffSegments.schedule.data : []"
                                    item-value="id"
                                    item-text="name"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                    label="Выбрать"
                                    append-icon="mdi-chevron-down"
                                    no-data-text="Результатов не найдено"
                                    v-model="indivLessonFilter.select_segment"
                                    outlined
                                    dense
                                    color="#629F33"
                                    style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                >
                                </v-autocomplete>
                              </v-col>
                              <v-col
                                  cols="12"
                                  sm="4"
                                  md="4"
                                  class="mt-3"
                              >
                                <label>Услуга</label>
                                <v-select
                                    @input="collectData"
                                    class="rounded-lg custom__select"
                                    v-model="indivLessonFilter.service"
                                    :items="clientEvents_def"
                                    ref="selectedEl6"
                                    item-text="name"
                                    item-value="service_id"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                    label="Выбрать"
                                    append-icon="mdi-chevron-down"
                                    outlined
                                    dense
                                    color="#629F33"
                                    style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                ></v-select>
                              </v-col>
                              <v-col
                                  cols="12"
                                  sm="4"
                                  md="4"
                                  class="mt-3"
                              >
                                <label>Статус</label>
                                <v-select
                                    @input="collectData"
                                    class="rounded-lg custom__select"
                                    v-model="indivLessonFilter.status"
                                    :items="statusTypes"
                                    ref="selectedEl2"
                                    item-text="type_name"
                                    item-value="type_id"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                    label="Выбрать"
                                    append-icon="mdi-chevron-down"
                                    outlined
                                    dense
                                    color="#629F33"
                                    style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                ></v-select>
                              </v-col>
                              <v-card-actions class="mt-4">
                                <template v-if="!dialogButton_indiv">
                                  <button
                                      class="button custom__button mt-5"
                                      type="button"
                                  >
                                    Применить
                                  </button>
                                </template>
                                <template v-else>
                                  <button
                                      class="button custom__button mt-5"
                                      type="button"
                                      style="background-color: #A13453 !important;color: #fff !important;"
                                      @click="filterEvents(indivLessonFilter)"
                                  >
                                    Применить
                                  </button>
                                  <button
                                      class="button custom__button mt-5 ml-3"
                                      type="button"
                                      style="background-color: #D53025 !important;color: #fff !important; width: auto !important; padding: 5px 20px;"
                                      @click="clearData"
                                  >
                                    Сбросить фильтр
                                  </button>
                                </template>
                              </v-card-actions>
                            </v-row>
                          </v-container>
                        </v-form>
                      </v-card-text>
           
                      <v-calendar
                          v-if="(toggle_category !== 2) && dialogDate"
                          ref="calendar"
                          locale="ru"
                          type="category"
                          :start="dateTable"
                          :categories="categories"
                          :category-show-all="true"
                          category-text="text"
                          :events="clientEvents"
                          :short-intervals="false"
                          :interval-count="getIntervalCount(toggle_day)"
                          :interval-height="82"
                          :first-time="toggle_day === 0 || toggle_day === 2 ? '07:00' : '14:00'"
                          :class="categories.length <= 6 ? 'custom__client-calendar ccustom_x' : 'show__all-category custom__client-calendar ccustom_x'"
                          @mouseup:time-category="endDragIndiv"
                      >
                        <template v-slot:day-label-header>
                          <span></span>
                        </template>
                        <template v-slot:event="{ eventParsed }">
                          <router-link :to="{ name: 'Lesson', params: { appointment_id: eventParsed.input.id} }" style="text-decoration: none">
                            <div style="padding: 10px" v-if="eventParsed.input.color !== '#f0f0f0'">
                              <div class="d-flex justify-space-between align-center" v-if="eventParsed.input.status < 2">
                                <div class="event-time">{{ eventParsed.start.time }} - {{ eventParsed.end.time }}</div>
                                <div class="event-count" >{{ eventParsed.input.count }}/{{ eventParsed.input.slots }}</div>
                              </div>
                              <div class="event-name" v-if="eventParsed.input.status < 2">{{ eventParsed.input.name }}</div>

                              <div class="event-name" v-else>ОТМЕНЕНО</div>
                            </div>
                          </router-link>
                  
                        </template>
                        <template v-slot:interval="{ category, date, time }">
                          <div v-for="duty in dutyEvents" :key="duty.id" >
                            <div v-for="dutyTime in duty.schedule_duty" :key="duty.id+dutyTime.startdate.date+dutyTime.startdate.time">
                              <div v-if="duty.id === category.value && dutyGrid(date, time, dutyTime)" class="duty-interval"></div>
                            </div>
                          </div>
                        </template>
                      </v-calendar>

                      <v-calendar
                          v-else-if="(toggle_category === 1) && !dialogDate"
                          ref="calendar"
                          locale="ru"
                          type="category"
                          :start="dateTable"
                          :categories="categories"
                          :category-show-all="true"
                          category-text="text"
                          :events="clientEvents"
                          :short-intervals="false"
                          :interval-count="getIntervalCount(toggle_day)"
                          :interval-height="82"
                          :first-time="toggle_day === 0 || toggle_day === 2 ? '07:00' : '14:00'"
                          :class="categories.length <= 6 ? 'custom__client-calendar ccustom_x' : 'show__all-category custom__client-calendar ccustom_x'"
                          @mouseup:time-category="endDragIndiv"
                      >
                        <template v-slot:day-label-header>
                          <span></span>
                        </template>
                        <template v-slot:event="{ eventParsed }">
                          <router-link :to="{ name: 'Lesson', params: { appointment_id: eventParsed.input.id} }" style="text-decoration: none">
                            <div style="padding: 10px" v-if="eventParsed.input.color !== '#f0f0f0'">
                              <div class="d-flex justify-space-between align-center" v-if="eventParsed.input.status < 2">
                                <div class="event-time">{{ eventParsed.start.time }} - {{ eventParsed.end.time }}</div>
                                <div class="event-count" >{{ eventParsed.input.count }}/{{ eventParsed.input.slots }}</div>
                              </div>
                              <div class="event-name" v-if="eventParsed.input.status < 2">{{ eventParsed.input.name }}</div>

                              <div class="event-name" v-else>ОТМЕНЕНО</div>
                            </div>
                          </router-link>
                  
                        </template>
                        <template v-slot:interval="{ category, date, time }">
                          <div v-for="duty in dutyEvents" :key="duty.id" >
                            <div v-for="dutyTime in duty.schedule_duty" :key="duty.id+dutyTime.startdate.date+dutyTime.startdate.time">
                              <div v-if="duty.id === category.value && dutyGrid(date, time, dutyTime)" class="duty-interval"></div>
                            </div>
                          </div>
                        </template>
                      </v-calendar>
                                 <!-- @mousedown:time-category="startTimeIndiv"
                          @mousemove:time-category="mouseMoveIndiv"
                          @mouseleave.native="cancelDragIndiv"
                        -->
                      <v-calendar
                          v-else-if="!dialogDate"
                          ref="weeklyCalendar"
                          v-model="focus"
                          locale="ru"
                          :type="type"
                          :weekdays="[1,2,3,4,5,6,0]"
                          :short-intervals="false"
                          :interval-count="getIntervalCount(toggle_day)"
                          :interval-height="82"
                          :first-time="toggle_day === 0 || toggle_day === 2 ? '07:00' : '14:00'"
                          :events="clientEvents"
                          event-overlap-mode="column"
                          class="custom__calendar"
                          @change="updateRange"
               
                          @mouseup:time-category="endDragIndiv"
                          
                      >
                        <template v-slot:day-label-header>
                          <span></span>
                        </template>
                        <template v-slot:event="{ eventParsed }">
                          <router-link v-if="eventParsed && eventParsed.input" :to="{ name: 'Lesson', params: { appointment_id: eventParsed.input.id} }" style="text-decoration: none">
                            <div style="padding: 10px" v-if="eventParsed.input.color !== '#f0f0f0'">
                              <div class="d-flex justify-space-between align-center" v-if="eventParsed.input.status < 2">
                                <div class="event-time">{{ eventParsed.start.time }} - {{ eventParsed.end.time }}</div>
                                <div class="event-count" >{{ eventParsed.input.count }}/{{ eventParsed.input.slots }}</div>
                              </div>
                              <div class="event-name" v-if="eventParsed.input.status < 2">{{ eventParsed.input.name }}</div>

                              <div class="event-name" v-else>ОТМЕНЕНО</div>
                            </div>
                          </router-link>
                          <div v-else @click="createIndivLesson">
                          </div>
                        </template>
                        <template v-slot:interval="{ date, time}">
                          <div v-for="duty in dutyEvents" :key="duty.id" >
                            <div v-for="dutyTime in duty.schedule_duty" :key="duty.id+dutyTime.startdate.date+dutyTime.startdate.time">
                              <div v-if="duty.name === indivLessonFilter.specialist[0] && dutyGrid(date, time, dutyTime)" class="duty-interval"></div>
                            </div>
                          </div>
                        </template>
                      </v-calendar>
                    </v-sheet>
                  </v-tab-item>
                  <v-tab-item>
                    <v-sheet class="rounded-lg">
                      <v-card-title
                          class="d-flex justify-space-between align-center"
                      >
                        <div class="calendar-options d-flex align-center">
                          <v-btn-toggle
                              v-model="toggle_date"
                              mandatory
                              class="ml-5 rounded-lg"
                          >
                            <v-btn @click="changeDay">
                              День
                            </v-btn>
                            <v-btn @click="changeWeek">
                              Неделя
                            </v-btn>
                          </v-btn-toggle>
                          <v-btn-toggle
                              v-model="toggle_week"
                              class="ml-5 rounded-lg"
                          >
                            <v-btn @click="prevAll" style="padding: 0 !important; min-width: 38px !important;">
                              <v-icon
                              >
                                mdi-chevron-left
                              </v-icon>
                            </v-btn>
                            <v-btn @click="nextAll" style="padding: 0 !important; min-width: 38px !important;">
                              <v-icon
                              >
                                mdi-chevron-right
                              </v-icon>
                            </v-btn>
                          </v-btn-toggle>

                          <!-- <VueDatePicker
                              no-title
                              no-header
                              disabled
                              color="#629f34"
                              class="ml-4"
                              style="flex: none !important;"
                              v-if="start && end && !dialogDate"
                          >
                            <template #activator>
                              <button
                                  class="button custom__date-button"
                                  ref="activator"
                                  type="button"
                              >
                                <v-icon
                                    dark
                                    small
                                    class="mr-2"
                                >
                                  mdi-calendar-blank-outline
                                </v-icon>  {{ start.day === end.day ? start.day : start.day + '-' + end.day }} {{ start.month === end.month ? months[start.month - 1] : months[start.month - 1] + ' - ' + months[end.month - 1]}}
                              </button>
                            </template>
                          </VueDatePicker>
                          <VueDatePicker
                              no-title
                              no-header
                              v-model="dateTable"
                              @onChange="typeToDate(dateTable)"
                              color="#629f34"
                              class="ml-4"
                              style="flex: none !important;"
                              v-if="dialogDate"
                          >
                            <template #activator="{ date }">
                              <button
                                  class="button custom__date-button"
                                  ref="activator"
                                  type="button"
                              >
                                <v-icon
                                    dark
                                    small
                                    class="mr-2"
                                >
                                  mdi-calendar-blank-outline
                                </v-icon> {{ date }}
                              </button>
                            </template>
                          </VueDatePicker> -->


                          <VueDatePicker
                              no-title
                              no-header
                              color="#629f34"
                              @onChange="typeToDate(date_all)"
                              v-model="date_all"
                              style="flex: none !important; margin-left:20px"
                          >
                            <template #activator="{ date }">
                              <button
                                  class="button custom__date-button"
                                  ref="activator"
                                  type="button"
                              >
                                <v-icon
                                    dark
                                    small
                                    class="mr-2"
                                >
                                  mdi-calendar-blank-outline
                                </v-icon>  {{ date }}
                              </button>
                            </template>
                          </VueDatePicker>
                          <v-btn-toggle
                              v-model="toggle_day_all"
                              mandatory
                              class="ml-5 rounded-lg"
                          >
                            <v-btn>
                              Утро
                            </v-btn>
                            <v-btn>
                              Вечер
                            </v-btn>
                            <v-btn>
                              Весь день
                            </v-btn>
                          </v-btn-toggle>
                        </div>
                        <div class="filter-schedule">
                          <v-btn
                              dark
                              class="filter-button"
                              @click="dialogFiler_all = !dialogFiler_all, events_def = events, clientEvents_def = clientEvents, allEvents_def = allEvents"
                          >
                            <img
                                class="mr-1"
                                src="/playground_assets/mediumfilter.svg"
                            >
                            Фильтр
                          </v-btn>
                        </div>
                      </v-card-title>
                      <v-card-text
                          v-show="dialogFiler_all"
                      >
                        <v-form
                            ref="allFilterForm"
                            v-model="valid_all"
                        >
                          <v-container>
                            <v-row>
                              <v-col
                                  cols="12"
                                  sm="4"
                                  md="3"
                              >
                                <label>Сотрудники</label>
                                <v-select
                                    @input="collectData"
                                    class="rounded-lg custom__select"
                                    v-model="allLessonFilter.specialist"
                                    :items="allEvents_def"
                                    item-value="specialist_id"
                                    item-text="specialist_name"
                                    ref="selectedEl1"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                    label="Выбрать"
                                    append-icon="mdi-chevron-down"
                                    outlined
                                    dense
                                    color="#629F33"
                                    item-color="#629F33"
                                    clearable
                                    multiple
                                    style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                >
                                  <template v-slot:selection="data">
                                    <span
                                        v-if="allLessonFilter.specialist.length === 1"
                                        v-bind="data.attrs"
                                    >
                                      {{ data.item.specialist_name }}
                                    </span>
                                    <div v-else-if="data.index === 0">
                                      Выбрано {{ allLessonFilter.specialist.length }} сотрудников
                                    </div>
                                  </template>
                                </v-select>
                              </v-col>
                              <v-col
                                  cols="12"
                                  sm="4"
                                  md="3"
                              >
                                <label>Тип</label>
                                <v-select
                                    @input="collectData"
                                    class="rounded-lg custom__select"
                                    v-model="allLessonFilter.lesson"
                                    :items="lessonTypes"
                                    ref="selectedEl2"
                                    item-value="type_id"
                                    item-text="type_name"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                    label="Выбрать"
                                    append-icon="mdi-chevron-down"
                                    outlined
                                    dense
                                    color="#629F33"
                                    style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                ></v-select>
                              </v-col>
                              <v-col
                                  cols="12"
                                  sm="4"
                                  md="3"
                              >
                                <label>Должность</label>
                                <v-select
                                    @input="collectData"
                                    class="rounded-lg custom__select"
                                    v-model="allLessonFilter.position"
                                    :items="allEvents_def"
                                    item-value="post_id"
                                    item-text="post_name"
                                    ref="selectedEl3"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                    label="Выбрать"
                                    append-icon="mdi-chevron-down"
                                    outlined
                                    dense
                                    color="#629F33"
                                    style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                ></v-select>
                              </v-col>
                              <v-col
                                  cols="12"
                                  sm="4"
                                  md="3"
                              >
                                <label>Помещение</label>
                                <!-- <v-select
                                    @input="collectData"
                                    class="rounded-lg custom__select"
                                    v-model="allLessonFilter.room"
                                    :items="(allLessonFilter.room && allLessonFilter.room.length > 0) ? allEvents_def : allEvents"
                                    item-value="room_id"
                                    item-text="room_name"
                                    ref="selectedEl4"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                    label="Выбрать"
                                    append-icon="mdi-chevron-down"
                                    outlined
                                    dense
                                    color="#629F33"
                                    item-color="#629F33"
                                    clearable
                                    multiple
                                    style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                >
                                  <template v-slot:selection="data">
                                    <span
                                        v-if="allLessonFilter.room.length === 1"
                                        v-bind="data.attrs"
                                    >
                                      {{ data.item.room_name }}
                                    </span>
                                    <div v-else-if="data.index === 0">
                                      Выбрано {{ allLessonFilter.room.length }} помещении
                                    </div>
                                  </template>
                                </v-select> -->

                                
                                <v-select
                                    @input="collectData"
                                    class="rounded-lg custom__select"
                                    v-model="allLessonFilter.room"
                                    :items="(allLessonFilter.room && allLessonFilter.room.length > 0) ? allEvents_def : allEvents"
                                    item-value="room_id"
                                    item-text="room_name"
                                    ref="selectedEl4"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                    label="Выбрать"
                                    append-icon="mdi-chevron-down"
                                    outlined
                                    dense
                                    color="#629F33"
                                    style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                ></v-select>

                              </v-col>
                              <v-col
                                  cols="12"
                                  sm="4"
                                  md="3"
                                  class="mt-3"
                              >
                                <label>Сегмент сотрудников</label>
                                <v-autocomplete
                                    @input="collectData"
                                    class="rounded-lg custom__select"
                                    :items="listStaffSegments ? listStaffSegments.schedule.data : []"
                                    item-text="name"
                                    item-value="id"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                    label="Выбрать"
                                    append-icon="mdi-chevron-down"
                                    no-data-text="Результатов не найдено"
                                    v-model="allLessonFilter.select_segment"
                                    outlined
                                    dense
                                    color="#629F33"
                                    style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                >
                                </v-autocomplete>

                                <!-- 
                                  :search-input.sync="allLessonFilter.search_client"
                                -->
                              </v-col>
                              <v-col
                                  cols="12"
                                  sm="4"
                                  md="3"
                                  class="mt-3"
                              >
                                <label>Услуга</label>
                                <v-select
                                    @input="collectData"
                                    class="rounded-lg custom__select"
                                    v-model="allLessonFilter.service"
                                    :items="allEvents_def"
                                    ref="selectedEl6"
                                    item-text="name"
                                    item-value="service_id"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                    label="Выбрать"
                                    append-icon="mdi-chevron-down"
                                    outlined
                                    dense
                                    color="#629F33"
                                    style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                ></v-select>
                              </v-col>
                              <v-col
                                  cols="12"
                                  sm="4"
                                  md="3"
                                  class="mt-3"
                              >
                                <label>Статус</label>
                                <v-select
                                    @input="collectData"
                                    class="rounded-lg custom__select"
                                    v-model="allLessonFilter.status"
                                    :items="statusTypes"
                                    ref="selectedEl2"
                                    item-text="type_name"
                                    item-value="type_id"
                                    :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                    label="Выбрать"
                                    append-icon="mdi-chevron-down"
                                    outlined
                                    dense
                                    color="#629F33"
                                    style="height: 40px;margin-top: 10px; border-color: #629F33 !important;"
                                ></v-select>
                              </v-col>
                              <v-col
                                  cols="12"
                                  sm="4"
                                  md="3"
                              >

                              </v-col>
                              <v-card-actions class="mt-4">
                                <template v-if="!dialogButton_all">
                                  <button
                                      class="button custom__button mt-5"
                                      type="button"
                                  >
                                    Применить
                                  </button>
                                </template>
                                <template v-else>
                                  <button
                                      class="button custom__button mt-5"
                                      type="button"
                                      style="background-color: #A13453 !important;color: #fff !important;"
                                      @click="filterEvents(allLessonFilter)"
                                  >
                                    Применить
                                  </button>
                                  <button
                                      class="button custom__button mt-5 ml-3"
                                      type="button"
                                      style="background-color: #D53025 !important;color: #fff !important; width: auto !important; padding: 5px 20px;"
                                      @click="clearData"
                                  >
                                    Сбросить фильтр
                                  </button>
                                </template>
                              </v-card-actions>
                            </v-row>
                          </v-container>
                        </v-form>
                      </v-card-text>
                      
                      <v-calendar
                      v-if="type === 'day'"
                          ref="calendar"
                          locale="ru"
                          type="category"
                          :start="date_all"
                          :categories="categoriesAllEvents"
                          :category-show-all="true"
                          category-text="text"
                          :events="allEvents"
                          :short-intervals="false"
                          :interval-count="getIntervalCount(toggle_day_all)"
                          :interval-height="82"
                          :first-time="toggle_day_all === 0 || toggle_day_all === 2 ? '07:00' : '14:00'"
                          :class="categoriesAllEvents.length <= 7 ? 'custom__client-calendar ccustom_x' : 'custom__client-calendar show__all-category ccustom_x'"
                      >
                        <template v-slot:day-label-header>
                          <span></span>
                        </template>
                        <template v-slot:event="{ eventParsed }">
                          <router-link :to="{ name: 'Lesson', params: { appointment_id: eventParsed.input.id} }" style="text-decoration: none">
                            <div style="padding: 10px" v-if="eventParsed.input.color !== '#f0f0f0'">
                              <div class="d-flex justify-space-between align-center" v-if="eventParsed.input.status < 2">
                                <div class="event-time">{{ eventParsed.start.time }} - {{ eventParsed.end.time }}</div>
                                <div class="event-count" >{{ eventParsed.input.count }}/{{ eventParsed.input.slots }}</div>
                              </div>
                              <div class="event-name" v-if="eventParsed.input.status < 2">{{ eventParsed.input.name }}</div>

                              <div class="event-name" v-else>ОТМЕНЕНО</div>
                            </div>
                          </router-link>
                        </template>
                        <template v-slot:interval="{ category, date, time}">
                          <div v-for="duty in dutyEvents" :key="duty.id">
                            <div v-for="dutyTime in duty.schedule_duty" :key="duty.id+dutyTime.startdate.date+dutyTime.startdate.time">
                              <div v-if="duty.id === category.value && dutyGrid(date, time, dutyTime)" class="duty-interval"></div>
                            </div>
                          </div>
                        </template>
                      </v-calendar>

                      <v-calendar
                          v-else-if="type === 'week'"
                          ref="weeklyCalendar"
                          v-model="focus"
                          locale="ru"
                          :type="type"
                          :weekdays="[1,2,3,4,5,6,0]"
                          :short-intervals="false"
                          :interval-count="getIntervalCount(toggle_day)"
                          :interval-height="82"
                          :first-time="toggle_day === 0 || toggle_day === 2 ? '07:00' : '14:00'"
                          :events="allEvents"
                          event-overlap-mode="column"
                          class="custom__calendar"
               
                          
                      >
                        <template v-slot:day-label-header>
                          <span></span>
                        </template>
                        <template v-slot:event="{ eventParsed }">
                          <router-link v-if="eventParsed && eventParsed.input" :to="{ name: 'Lesson', params: { appointment_id: eventParsed.input.id} }" style="text-decoration: none">
                            <div style="padding: 10px" v-if="eventParsed.input.color !== '#f0f0f0'">
                              <div class="d-flex justify-space-between align-center" v-if="eventParsed.input.status < 2">
                                <div class="event-time">{{ eventParsed.start.time }} - {{ eventParsed.end.time }}</div>
                                <div class="event-count" >{{ eventParsed.input.count }}/{{ eventParsed.input.slots }}</div>
                              </div>
                              <div class="event-name" v-if="eventParsed.input.status < 2">{{ eventParsed.input.name }}</div>

                              <div class="event-name" v-else>ОТМЕНЕНО</div>
                            </div>
                          </router-link>
                      
                        </template>
                        <template v-slot:interval="{ date, time}">
                          <div v-for="duty in dutyEvents" :key="duty.id" >
                            <div v-for="dutyTime in duty.schedule_duty" :key="duty.id+dutyTime.startdate.date+dutyTime.startdate.time">
                              <div v-if="duty.name === indivLessonFilter.specialist[0] && dutyGrid(date, time, dutyTime)" class="duty-interval"></div>
                            </div>
                          </div>
                        </template>
                      </v-calendar>

                    </v-sheet>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
              <!-- <v-skeleton-loader
                        v-else
                        type="table-tbody"
                    >
                    </v-skeleton-loader> -->
            </v-row>
          </v-container>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import {VueDatePicker} from "@mathieustan/vue-datepicker";
import {scheduleActionTypes} from "@/store/modules/schedule";
import {clientActionTypes} from '@/store/modules/client';
import {mapState} from "vuex";
import {lessonActionTypes} from "@/store/modules/lesson";
import {getItem, setItem} from "@/helpers/persistanceStorage";

export default {
  name: 'Schedule',
  props: ['from','service','client_id','client_name','specialist_main'],
  components: {
    VueDatePicker,
    Header,
    Menu
  },
  data() {
    return {
      date: new Date(),
      start: null,
      end: null,
      dateTable: new Date(),
      date_all: new Date(),
      endDay: null,
      endMonth: null,
      dragEvent: null,
      dragStart: null,
      createEvent: null,
      createStart: null,
      extendOriginal: null,
      focus: '',
      focus_all: '',
      valid: true,
      valid_indiv: true,
      valid_all: true,
      selected: [],
      selected_indiv: [],
      selected_all: [],
      groupLessonFilter: {
        specialist: [],
        position: [],
        room: null,
        search_client: '',
        select_client: null,
        service: null,
        status: null,
      },
      indivLessonFilter: {
        specialist: [],
        position: [],
        room: null,
        search_client: '',
        select_client: null,
        service: null,
        status: null,
      },
      allLessonFilter: {
        specialist: [],
        lesson: null,
        position: [],
        room: null,
        search_client: '',
        select_client: null,
        service: null,
        status: null,
      },
      lessonTypes: [
        {type_id: 0, type_name: 'Персональное занятие'},
        {type_id: 1, type_name: 'Групповое занятие'}
      ],
      statusTypes: [
        {type_id: 0, type_name: 'Запланировано'},
        {type_id: 1, type_name: 'Выполнено'},
        {type_id: 2, type_name: 'Отменено'},
      ],
      toggle_date: 0,
      toggle_date_all: 1,
      toggle_category: 0,
      toggle_category_all: 0,
      type: 'day',
      type_all: 'week',
      toggle_week: null,
      toggle_week_all: null,
      toggle_day: 2,
      toggle_day_all: 2,
      dialogDate: true,
      dialogDate_all: false,
      dialogFiler: false,
      dialogFiler_indiv: false,
      dialogFiler_all: false,
      dialogButton: false,
      dialogButton_indiv: false,
      dialogButton_all: false,
      schedule_tab: 0,
      schedules: [
        {tab: 'Групповые занятия'},
        {tab: 'Индивидуальные занятия'},
        {tab: 'Все'},
      ],
      categories: [],
      categoriesAllEvents: [],
      dutyEvents: [],
      events: [],
      clientEvents: [],
      allEvents: [],
      months: [
        'январь',
        'февраль',
        'март',
        'апрель',
        'май',
        'июнь',
        'июль',
        'август',
        'сентябрь',
        'октябрь',
        'ноябрь',
        'декабрь'
      ],
      range_updated:false,
      specialist_list_def:[],
      clientEvents_def:[],
      events_def:[],
      allEvents_def:[],
      events_def_def:[]
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.schedule.isLoading,
      listClient: state => state.client.listClient,
      schedule: state => state.schedule.data,
      listStaffSegments: state => state.schedule.segmentsData,
      validationErrors: state => state.schedule.validationErrors,
    })
  },
  // destroyed: function(){
  //   setItem('schedule-service', null)
  //   setItem('schedule-client_id', null)
  //   setItem('schedule-client_name', null)
  //   setItem('schedule-search_client', null)
  //   setItem('schedule-select_client', null)
  // },
    destroyed: function(){
    setItem('schedule-lesson_specialist', null)
    setItem('schedule-lesson_date', null)
    setItem('schedule-lesson_starttime', null)
    setItem('schedule-search_client', null)
    setItem('schedule-select_client', null)
  },
  mounted() {
    ////////console.log(this.from)
    ////////console.log(getItem('tog-cat'))
    ////////console.log(getItem('schedule-service'))
    setItem('sales-monitor-specialist_id', null);
    setItem('sales-monitor-specialist_type', null);
    setItem('sales-monitor-datetype', null);
    setItem('sales-monitor-datetype_date', null);

    setItem('report_12',null);
    setItem('report_13',null);
    setItem('report_14',null);
    setItem('report_15',null);
    setItem('report_16',null);
    setItem('report_17',null);
    
    setItem('report_newclient_id',null);

    if (this.from === 'reception' && this.service && this.service !== null && this.service !== 'null') {

      ////////console.log(this.service)


      this.service !== undefined ? setItem('schedule-service', JSON.stringify(this.service)) : this.service = JSON.parse(getItem('schedule-service'));
      this.client_id !== undefined ? setItem('schedule-client_id', this.client_id) : this.client_id = getItem('schedule-client_id');
      this.client_name !== undefined ? setItem('schedule-client_name', this.client_name) : this.client_name = getItem('schedule-client_name');

    } else if(this.from === 'create-lesson' || this.from === 'lesson') {
      //this.service = null
      if(getItem('schedule-service') && getItem('schedule-service') !== null && getItem('schedule-service') !== 'null' && getItem('schedule-service') !== undefined){
        this.service = JSON.parse(getItem('schedule-service'))
      }
     // this.service !== undefined ? setItem('schedule-service', JSON.stringify(this.service)) : this.service = JSON.parse(getItem('schedule-service'));
    } else {
      //this.service = null
      //setItem('schedule-service',null)
    }
    
    if(this.service && this.service.service_type.toString()){
      ////////console.log(this.service)
      this.schedule_tab = (this.service && this.service.service_type.toString() && this.service.service_type.toString() === '0') ? 1 : 0
    } else {

      ////////console.log(getItem('tog-cat'))
      ////////console.log(getItem('toggle_category_all'))

      this.schedule_tab = getItem('tog-cat') ? +getItem('tog-cat') : 0

      if(getItem('toggle_category') && getItem('toggle_category') !== null && getItem('toggle_category') !== 'null'){
        ////////console.log('tuga')
        this.toggle_category = +getItem('toggle_category')
      }
      if(getItem('toggle_category_all') && getItem('toggle_category_all') !== null && getItem('toggle_category_all') !== 'null'){
        ////////console.log('tuga_all')
        this.toggle_category_all = +getItem('toggle_category_all')
      }


    }

    //this.toggle_date = 0

    this.$store.dispatch(scheduleActionTypes.getStaffSegments, {
      service_id: this.service ? this.service.service_id : null
    })
    .then((response) => {
      ////////console.log(response)
    });

      // this.$store.dispatch(scheduleActionTypes.getScheduleDuty, {
      //   start_date: this.dateTable,
      //   end_date: this.dateTable
      // }).then((response) => {
      //   this.dutyEvents = response.duty;
      // })

        if(getItem('spec_main') && getItem('spec_main') !== null && getItem('spec_main') !== 'null' && getItem('spec_main') !== undefined) {
          this.specialist_main = JSON.parse(getItem('spec_main'))
        }

        //////console.log(this.specialist_main)
      
  },
  methods: {
    collectData(selected){
      if (this.schedule_tab === 0) {
        this.selected.push(selected)
        this.dialogButton = true;
      }
      if (this.schedule_tab === 1) {
        this.selected_indiv.push(selected)
        this.dialogButton_indiv = true;
      }
      if (this.schedule_tab === 2) {
        this.selected_all.push(selected)
        this.dialogButton_all = true;
      }
    },
    clearData(){
      ////////console.log('clear')
      ////////console.log(this.toggle_category_all)
      this.specialist_main = null
      setItem('spec_main', null)
      //setItem('schedule-service',null)
      if (this.schedule_tab === 0) {
        ////////console.log('clear1')
        this.$refs.groupFilterForm.reset();
        this.selected.length = 0;
        this.dialogButton = false;
        if (this.toggle_date === 0) {
          ////////console.log('clear2')
          this.$store.dispatch(scheduleActionTypes.getSchedule, {
            start_date: this.dateTable,
            end_date: this.dateTable,
            service_id: this.service ? this.service.service_id : null,
            service_specialist: this.specialist_main ? this.specialist_main : null
          }).then((response) => {

            if (this.toggle_category_all === 0) {

              ////////console.log("gggwp0")

                this.events = response.schedule?.group

                let categories = [];
                for (let item of this.events) {
                  let searchObject = categories.find((category) => category.text === item.category);
                  if(searchObject === undefined) {
                    categories.push({
                      text: item.category,
                      value: item.specialist_id
                    })
                  }
                }
                this.categories = categories;
            } else {

              ////////console.log("gggwp")

              for (let item of response.schedule?.group) {
                item.category = item.room_name
              }
              this.events = response.schedule?.group
              this.$store.dispatch(lessonActionTypes.getRoomList, {
                for_lesson: true
              })
                .then((response) => {
                  if (response.success) {
                    let categories = [];
                    for (let item of response.room) {
                      if(categories.indexOf(item.name) === -1) {
                        categories.push(item.name)
                      }
                    }
                    this.categories = categories;
                  }
                });
            }
     

          })
        }
        if (this.toggle_date === 1) {
          this.$store.dispatch(scheduleActionTypes.getSchedule, {
            start_date: this.start.date,
            end_date: this.end.date,
            service_id: this.service ? this.service.service_id : null,
            service_specialist: this.specialist_main ? this.specialist_main : null
          }).then((response) => {
            this.events = response.schedule?.group

            let categories = [];
            for (let item of this.events) {
              let searchObject = categories.find((category) => category.text === item.category);
              if(searchObject === undefined) {
                categories.push({
                  text: item.category,
                  value: item.specialist_id
                })
              }
            }
            this.categories = categories;

          })
        }
      }
      if (this.schedule_tab === 1) {

        this.$refs.indivFilterForm.reset();
        this.selected.length = 0;
        this.dialogButton_indiv = false;
        if (this.toggle_date === 0) {
          ////////console.log('clear2')
          this.$store.dispatch(scheduleActionTypes.getSchedule, {
            start_date: this.dateTable,
            end_date: this.dateTable,
            service_id: this.service ? this.service.service_id : null,
            service_specialist: this.specialist_main ? this.specialist_main : null
          }).then((response) => {

            if (this.toggle_category_all === 0) {

              ////////console.log("gggwp0")

              this.clientEvents = response.schedule?.indiv

                let categories = [];
                for (let item of this.clientEvents) {
                  let searchObject = categories.find((category) => category.text === item.category);
                  if(searchObject === undefined) {
                    categories.push({
                      text: item.category,
                      value: item.specialist_id
                    })
                  }
                }
                this.categories = categories;
            } else {

              ////////console.log("gggwp")

              for (let item of response.schedule?.indiv) {
                item.category = item.room_name
              }
              this.clientEvents = response.schedule?.indiv
              this.$store.dispatch(lessonActionTypes.getRoomList, {
                for_lesson: true
              })
                .then((response) => {
                  if (response.success) {
                    let categories = [];
                    for (let item of response.room) {
                      if(categories.indexOf(item.name) === -1) {
                        categories.push(item.name)
                      }
                    }
                    this.categories = categories;
                  }
                });
            }
     

          })
        }
        if (this.toggle_date === 1) {
          this.$store.dispatch(scheduleActionTypes.getSchedule, {
            start_date: this.start.date,
            end_date: this.end.date,
            service_id: this.service ? this.service.service_id : null,
            service_specialist: this.specialist_main ? this.specialist_main : null
          }).then((response) => {
            this.clientEvents = response.schedule?.indiv

            let categories = [];
            for (let item of this.clientEvents) {
              let searchObject = categories.find((category) => category.text === item.category);
              if(searchObject === undefined) {
                categories.push({
                  text: item.category,
                  value: item.specialist_id
                })
              }
            }
            this.categories = categories;

          })
        }

        // this.$refs.indivFilterForm.reset();
        // this.selected_indiv.length = 0;
        // this.dialogButton_indiv = false;
        // if (this.toggle_category === 0) {
        //   this.$store.dispatch(scheduleActionTypes.getSchedule, {
        //     start_date: this.date,
        //     end_date: this.date,
        //     service_id: this.service ? this.service.service_id : null,
        //     service_specialist: this.specialist_main ? this.specialist_main : null
        //   }).then((response) => {
        //     this.clientEvents = response.schedule?.indiv
        //     let categories = [];
        //     for (let item of this.clientEvents) {
        //       let searchObject = categories.find((category) => category.text === item.category);
        //       if(searchObject === undefined) {
        //         categories.push({
        //           text: item.category,
        //           value: item.specialist_id
        //         })
        //       }
        //     }
        //     this.categories = categories;
        //   })
        // } else {
        //   this.$store.dispatch(scheduleActionTypes.getSchedule, {
        //     start_date: this.date,
        //     end_date: this.date,
        //     service_id: this.service ? this.service.service_id : null,
        //     service_specialist: this.specialist_main ? this.specialist_main : null
        //   }).then((response) => {
        //     if (response.success) {
        //       for (let item of response.schedule?.indiv) {
        //         item.category = item.room_name
        //       }
        //       this.clientEvents = response.schedule?.indiv
        //       this.$store.dispatch(lessonActionTypes.getRoomList, {
        //         for_lesson: true
        //       })
        //         .then((response) => {
        //           if (response.success) {
        //             let categories = [];
        //             for (let item of response.room) {
        //               if(categories.indexOf(item.name) === -1) {
        //                 categories.push(item.name)
        //               }
        //             }
        //             this.categories = categories;
        //           }
        //         });
        //     }
        //   })
        // }
      }
      if (this.schedule_tab === 2) {
        this.$refs.allFilterForm.reset();
        this.selected_all.length = 0;
        this.dialogButton_all = false;
        if (this.toggle_category === 0) {
          this.$store.dispatch(scheduleActionTypes.getSchedule, {
            start_date: this.date_all,
            end_date: this.date_all,
            service_id: this.service ? this.service.service_id : null,
            service_specialist: this.specialist_main ? this.specialist_main : null
          }).then((response) => {
            this.allEvents = response.schedule?.all
            let categories = [];
            for (let item of this.allEvents) {
              let searchObject = categories.find((category) => category.text === item.category);
              if(searchObject === undefined) {
                categories.push({
                  text: item.category,
                  value: item.specialist_id
                })
              }
            }
            this.categoriesAllEvents = categories;
          })
        } else {
          this.$store.dispatch(scheduleActionTypes.getSchedule, {
            start_date: this.date_all,
            end_date: this.date_all,
            service_id: this.service ? this.service.service_id : null,
            service_specialist: this.specialist_main ? this.specialist_main : null
          }).then((response) => {
            if (response.success) {
              for (let item of response.schedule?.all) {
                item.category = item.room_name
              }
              this.allEvents = response.schedule?.all
              this.$store.dispatch(lessonActionTypes.getRoomList, {
                for_lesson: true
              })
                  .then((response) => {
                    if (response.success) {
                      let categories = [];
                      for (let item of response.room) {
                        if(categories.indexOf(item.name) === -1) {
                          categories.push(item.name)
                        }
                      }
                      this.categoriesAllEvents = categories;
                    }
                  });
            }
          })
        }
      }
    },
    typeToDate(date) {
      if (this.schedule_tab === 0) {
        this.dateTable = new Date(date);
      }
      if (this.schedule_tab === 1) {
        this.dateTable = new Date(date);
      }
      ////////console.log(this.dateTable)
      if (this.schedule_tab === 2) {
        this.dateTable_all = new Date(date);
      }
    },
    prev () {
      ////////console.log(this.dateTable)
      this.dialogDate ? this.dateTable = new Date(this.dateTable.setDate(this.dateTable.getDate() - 1)) : this.$refs.weeklyCalendar.prev()
    },
    prevAll () {
      // this.dialogDate_all ? this.dateTable_all = new Date(this.dateTable_all.setDate(this.dateTable_all.getDate() - 1)) : this.$refs.weeklyAllCalendar.prev()
      // this.date_all ? this.date_all = new Date(this.date_all.setDate(this.date_all.getDate() - 1)) : this.$refs.weeklyAllCalendar.prev()
      this.date_all = new Date(this.date_all.setDate(this.date_all.getDate() - 1))
    },
    next () {
      // if (this.schedule_tab === 0) {
      //   this.dateTable = new Date(date);
      // }
      // if (this.schedule_tab === 1) {
      //   this.dateTable = new Date(date);
      // }
  
      ////////console.log(this.dateTable)
      ////////console.log(this.dialogDate)

      if(this.dialogDate) {
        this.dateTable = new Date(this.dateTable.setDate(this.dateTable.getDate() + 1))
      } else {
        //this.dateTable = new Date(this.dateTable.setDate(this.dateTable.getDate() + 7))
        this.$refs.weeklyCalendar.next()

        ////////console.log(this.$refs.weeklyCalendar)
      }

      
    },
    nextAll () {
      // this.dialogDate_all ? this.dateTable_all = new Date(this.dateTable_all.setDate(this.dateTable_all.getDate() + 1)) : this.$refs.weeklyAllCalendar.next()
      // this.date_all ? this.date_all = new Date(this.date_all.setDate(this.date_all.getDate() + 1)) : this.$refs.weeklyAllCalendar.next()
      this.date_all = new Date(this.date_all.setDate(this.date_all.getDate() + 1))
    },
    startTimeGroup(tms) {
      if (this.service && this.service !== null && this.service.service_type === 1) {
        const mouse = this.toTime(tms)
        if (this.dragEvent && this.dragTime === null) {
          const start = this.dragEvent.start

          this.dragTime = mouse - start
        } else {
          this.createStart = this.roundTime(mouse)
          this.createEvent = {
            name: this.service.service_name,
            color: 'blue',
            start: this.createStart,
            end: this.createStart,
            timed: true,
          }
          this.events.push(this.createEvent)
        }
      }
    },
    mouseMoveGroup(tms) {
      if (this.service && this.service.service_type === 1) {
        const mouse = this.toTime(tms);
        if (this.dragEvent && this.dragTime !== null) {
          const start = this.dragEvent.start
          const end = this.dragEvent.end
          const duration = end - start
          const newStartTime = mouse - this.dragTime
          const newStart = this.roundTime(newStartTime)
          const newEnd = newStart + duration

          this.dragEvent.start = newStart
          this.dragEvent.end = newEnd
        } else if (this.createEvent && this.createStart !== null) {
          const mouseRounded = this.roundTime(mouse, false)
          const min = Math.min(mouseRounded, this.createStart)
          const max = Math.max(mouseRounded, this.createStart)

          this.createEvent.start = min
          this.createEvent.end = max
        }
      }
    },
    createGroupLesson() {
      ////////console.log('create group')
      if (this.service && this.service.service_type === 1) {
        let date = new Date(this.createStart);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear().toString();
        this.$router.push({
          name: 'CreateLesson',
          params: {
            service_id: this.service ? this.service.service_id : null,
            service_type: this.service.service_type,
            lesson_specialist: null,
            search_client: this.client_name,
            select_client: this.client_id,
            lesson_date: year + '-' + month + '-' + day,
            lesson_starttime: ("0" + date.getHours()).slice(-2) + ':' + ("0" + date.getMinutes()).slice(-2)
          }
        });
      } else {
        let date = new Date(this.createStart);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear().toString();
        this.$router.push({
          name: 'CreateLesson',
          params: {
            service_id: this.service ? this.service.service_id : null,
            service_type: 1,
            lesson_specialist: null,
            search_client: this.client_name,
            select_client: this.client_id,
            lesson_date: year + '-' + month + '-' + day,
            lesson_starttime: ("0" + date.getHours()).slice(-2) + ':' + ("0" + date.getMinutes()).slice(-2)
          }
        });
      }
    },
    endDragGroup(tms) {
      ////////console.log(tms)
      let pointHour = +tms.time.split(':')[0]
      ////////console.log(pointHour)

      ////////console.log(getItem('schedule-service'))
      ////////console.log(this.service)
      // let emptyEvent = true
      // for(let i = 0; i < this.events.length; i++){
      //   if(this.events[i].specialist_id === tms.category.value){
      //     let startPoint = +this.events[i].start.split('T')[1].split(':')[0]
      //     let endPoint = +this.events[i].end.split('T')[1].split(':')[0]
      //       if(pointHour >= startPoint && pointHour < endPoint){
      //         emptyEvent = false
      //       } else {
      //       }

      //   }
      // }

      //if(emptyEvent === true){
      
        if (this.service && this.service.service_type === 1) {

          let date = new Date(this.createStart);
          const day = date.getDate().toString().padStart(2, '0');
          const month = (date.getMonth() + 1).toString().padStart(2, '0');
          const year = date.getFullYear().toString();
          this.$router.push({
            name: 'CreateLesson',
            params: {
              service_id: this.service.service_id,
              service_type: this.service.service_type,
              lesson_specialist: tms.category.value,
              search_client: this.client_name,
              select_client: this.client_id,
              lesson_date: tms.date,
              lesson_starttime: (tms.hour < 10) ? ('0' + tms.hour + ':00') : (tms.hour + ':00')
            }
          });

        } else if(!this.service) {
          // let date = tms.date;
          // const day = tms.day.toString().padStart(2, '0');
          // const month = tms.month.toString().padStart(2, '0');
          // const year = tms.year.toString();

          // ////////console.log(day)
          // ////////console.log(month)
          // ////////console.log(year)
          // this.$router.push({
          //   name: 'CreateLesson',
          //   params: {
          //     service_id: null,
          //     service_type:1,
          //     lesson_specialist: tms.category.value,
          //     search_client: this.client_name,
          //     select_client: this.client_id,
          //     lesson_date: year + '-' + month + '-' + day,
          //     lesson_starttime: tms.time
          //   }
          // });
        }

      //}
    },
    cancelDragGroup() {
      if (this.service && this.service.service_type === 1) {
        if (this.createEvent) {
          if (this.extendOriginal) {
            this.createEvent.end = this.extendOriginal
          } else {
            const i = this.events.indexOf(this.createEvent)
            if (i !== -1) {
              this.events.splice(i, 1)
            }
          }
        }

        this.createEvent = null
        this.createStart = null
        this.dragTime = null
        this.dragEvent = null
      }
    },
    startTimeIndiv(tms) {
      getItem('schedule-service')
      if (this.service !== null && this.service !== undefined && this.service !== 'undefined' && this.service.service_type === 0) {
        if (this.service.service_type === 0) {
          const mouse = this.toTime(tms)
          if (this.dragEvent && this.dragTime === null) {
            const start = this.dragEvent.start

            this.dragTime = mouse - start
          } else {
            this.createStart = this.roundTime(mouse)
            this.createEvent = {
              name: this.service.service_name,
              color: 'blue',
              start: this.createStart,
              end: this.createStart,
              timed: true,
            }
            this.clientEvents.push(this.createEvent)
          }
        }
      } else {
        this.service = JSON.parse(getItem('schedule-service'))
        if (this.service && this.service.service_type.toString() && this.service.service_type === 0) {
          const mouse = this.toTime(tms)
          if (this.dragEvent && this.dragTime === null) {
            const start = this.dragEvent.start

            this.dragTime = mouse - start
          } else {
            this.createStart = this.roundTime(mouse)
            this.createEvent = {
              name: this.service.service_name,
              color: 'blue',
              start: this.createStart,
              end: this.createStart,
              timed: true,
            }
            this.clientEvents.push(this.createEvent)
          }
        }
      }
    },
    mouseMoveIndiv(tms) {
    if (this.service && this.service.service_type === 0) {
        const mouse = this.toTime(tms);
        if (this.dragEvent && this.dragTime !== null) {
          const start = this.dragEvent.start
          const end = this.dragEvent.end
          const duration = end - start
          const newStartTime = mouse - this.dragTime
          const newStart = this.roundTime(newStartTime)
          const newEnd = newStart + duration

          this.dragEvent.start = newStart
          this.dragEvent.end = newEnd
        } else if (this.createEvent && this.createStart !== null) {
          const mouseRounded = this.roundTime(mouse, false)
          const min = Math.min(mouseRounded, this.createStart)
          const max = Math.max(mouseRounded, this.createStart)

          this.createEvent.start = min
          this.createEvent.end = max
        }
      }
    },
    
    endDragIndiv(tms) {
      //////console.log(tms)
      let pointHour = +tms.time.split(':')[0]
      ////////console.log(pointHour)
      // let emptyEvent = true
      // for(let i = 0; i < this.clientEvents.length; i++){
      //   if(this.clientEvents[i].specialist_id === tms.category.value){
      //     let startPoint = +this.clientEvents[i].start.split('T')[1].split(':')[0]
      //     let endPoint = +this.clientEvents[i].end.split('T')[1].split(':')[0]
      //       if(pointHour >= startPoint && pointHour < endPoint){
      //         emptyEvent = false
      //       } else {
      //       }

      //   }
      // }

      //if(emptyEvent === true){


        //return;
      
        if (this.service && this.service.service_type === 0) {

          if(this.specialist_main) {
            setItem('spec_main', JSON.stringify(this.specialist_main))
          }

          let date = new Date(this.createStart);
          const day = date.getDate().toString().padStart(2, '0');
          const month = (date.getMonth() + 1).toString().padStart(2, '0');
          const year = date.getFullYear().toString();
          this.$router.push({
            name: 'CreateLesson',
            params: {
              service_id: this.service.service_id,
              service_type: this.service.service_type,
              lesson_specialist: {id:tms.category.value, name:tms.category.categoryName},
              search_client: this.client_name,
              select_client: this.client_id,
              lesson_date: tms.date,
              lesson_starttime: (tms.hour < 10) ? ('0' + tms.hour + ':00') : (tms.hour + ':00')
            }
          });

        } else if(!this.service) {
          // let date = tms.date;
          // const day = tms.day.toString().padStart(2, '0');
          // const month = tms.month.toString().padStart(2, '0');
          // const year = tms.year.toString();

          // ////////console.log(day)
          // ////////console.log(month)
          // ////////console.log(year)
          // this.$router.push({
          //   name: 'CreateLesson',
          //   params: {
          //     service_id: null,
          //     service_type:0,
          //     lesson_specialist: {id:tms.category.value, name:tms.category.categoryName},
          //     search_client: this.client_name,
          //     select_client: this.client_id,
          //     lesson_date: tms.date,
          //     lesson_starttime: (tms.hour < 10) ? ('0' + tms.hour + ':00') : (tms.hour + ':00')
          //   }
          // });
        }

      //}

    },
    createIndivLesson(item) {
      //////console.log('create indiv')
      ////////console.log(item)
      if (this.service && this.service.service_type === 0) {
        let date = new Date(this.createStart);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear().toString();
        this.$router.push({
          name: 'CreateLesson',
          params: {
            service_id: this.service.service_id,
            service_type: this.service.service_type,
            lesson_specialist: tms.category.value,
            search_client: this.client_name,
            select_client: this.client_id,
            lesson_date: year + '-' + month + '-' + day,
            lesson_starttime: ("0" + date.getHours()).slice(-2) + ':' + ("0" + date.getMinutes()).slice(-2)
          }
        });
      } else if(!this.service) {
           let date = new Date(this.createStart);
          const day = date.getDate().toString().padStart(2, '0');
          const month = (date.getMonth() + 1).toString().padStart(2, '0');
          const year = date.getFullYear().toString();
          this.$router.push({
            name: 'CreateLesson',
            params: {
              service_id: this.service.service_id,
              service_type: 0,
              lesson_specialist: tms.category.value,
              search_client: this.client_name,
              select_client: this.client_id,
              lesson_date: year + '-' + month + '-' + day,
              lesson_starttime: ("0" + date.getHours()).slice(-2) + ':' + ("0" + date.getMinutes()).slice(-2)
            }
          });
      }
    },
    cancelDragIndiv(item) {
      if (this.service && this.service.service_type === 0) {
        if (this.createEvent) {
          if (this.extendOriginal) {
            this.createEvent.end = this.extendOriginal
          } else {
            const i = this.clientEvents.indexOf(this.createEvent)
            if (i !== -1) {
              this.clientEvents.splice(i, 1)
            }
          }
        }

        this.createEvent = null
        this.createStart = null
        this.dragTime = null
        this.dragEvent = null
      }
    },
    roundTime(time, down = true) {
      const roundTo = 15 // minutes
      const roundDownTime = roundTo * 60 * 1000
      return down
          ? time - time % roundDownTime
          : time + (roundDownTime - (time % roundDownTime))
    },
    toTime(tms) {
      return new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute).getTime();
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a
    },
    updateRange ({ start, end }) {
     
      this.start = start;
      this.end = end;
      this.events = [];
      this.clientEvents = [];

      this.isLoading = true

      if((this.range_updated === true) || this.service || +getItem('toggle_category') || +getItem('toggle_category_all')) {
        ////console.log('range_updated was')

        this.$store.dispatch(scheduleActionTypes.getScheduleDuty, {
          start_date: this.start.date,
          end_date: this.end.date,
          service_id: this.service ? this.service.service_id : null
        }).then((response) => {
          this.dutyEvents = response.duty;
        })

        if(this.indivLessonFilter && this.indivLessonFilter.specialist && this.indivLessonFilter.specialist.length > 0){
          if(this.type === 'week'){
            this.toggle_category = 2
          }
        }
      } else {

        ////////console.log('range_updated')

        ////////console.log(start)
        ////////console.log(end)

        this.start = start;
      this.end = end;

      this.$store.dispatch(scheduleActionTypes.getSchedule, {
        start_date: this.start.date,
        end_date: this.end.date,
        service_id: this.service ? this.service.service_id : null,
        service_specialist: this.specialist_main ? this.specialist_main : null
      }).then((response) => {
        this.events = response.schedule?.group
        this.clientEvents = response.schedule?.indiv
        this.allEvents = response.schedule?.all

        ////////console.log(this.toggle_category)

        if(this.toggle_category === 2){
          this.events = response.schedule?.indiv
        

        let categories = [];
              for (let item of this.events) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.specialist_id
                  })
                }
              }
              this.categories = categories;
            } else {

              if(this.schedule_tab === 0){
                let categories = [];
                for (let item of this.events) {
                  let searchObject = categories.find((category) => category.text === item.category);
                  if(searchObject === undefined) {
                    categories.push({
                      text: item.category,
                      value: item.specialist_id
                    })
                  }
                }
                this.categories = categories;
              } else {
                let categories = [];
                for (let item of this.clientEvents) {
                  let searchObject = categories.find((category) => category.text === item.category);
                  if(searchObject === undefined) {
                    categories.push({
                      text: item.category,
                      value: item.specialist_id
                    })
                  }
                }
                this.categories = categories;
              }
         
            }

              // let categories2 = [];
              // for (let item of this.events) {
              //   let searchObject = categories2.find((category) => category.text === item.category);
              //   if(searchObject === undefined) {
              //     categories2.push({
              //       text: item.category,
              //       value: item.specialist_id
              //     })
              //   }
              // }
              // this.categories = categories2;

        this.$store.dispatch(scheduleActionTypes.getScheduleDuty, {
          start_date: this.start.date,
          end_date: this.end.date
        }).then((response) => {
          this.dutyEvents = response.duty;
        })

        if (this.toggle_date === 0) {
          this.range_updated = true
        } 

        if(this.indivLessonFilter && this.indivLessonFilter.specialist && this.indivLessonFilter.specialist.length > 0){
          if(this.type === 'week'){
            this.toggle_category = 2
          }
          
        }

        // ////console.log(this.clientEvents)
        // ////console.log(this.clientEvents_def)
        // ////console.log(this.allEvents)
        // ////console.log(this.allEvents_def)

      })

    }

    ////console.log('update range')
    
    // if(this.clientEvents_def_def.length === 0){
    //   ////console.log('set ind def def')

    //   this.clientEvents_def_def = this.clientEvents

    // }

    // if(this.events_def_def.length === 0){
    //   ////console.log('set group def def')

    //   this.events_def_def = this.events

    // }

    // if(this.allEvents_def_def.length === 0){
    //   ////console.log('set all def def')

    //   this.allEvents_def_def = this.allEvents

    // }

    },
    dutyGrid(gridDate, gridTime, dutyTime) {
      const currentTime = new Date(`${gridDate} ${gridTime}`);
      const startTime = new Date(`${dutyTime.startdate.date} ${dutyTime.startdate.time}`);
      const endTime = new Date(`${dutyTime.enddate.date} ${dutyTime.enddate.time}`);
      return currentTime >= startTime && currentTime < endTime;
    },
    changeDay() {
      if (this.schedule_tab === 0) {
        this.type = 'day';
        this.dialogDate = true;
      }
      if (this.schedule_tab === 1) {
        this.type = 'day';
        this.dialogDate = true;
      }
      if (this.schedule_tab === 2) {
        this.type_all = 'day';
        this.dialogDate_all = true;
      }
    },
    changeWeek() {
      if (this.schedule_tab === 0) {
        this.type_all = 'week';
        this.dialogDate_all = false;
      }
      if (this.schedule_tab === 1) {
        this.type_all = 'week';
        this.dialogDate_all = false;
      }
      if (this.schedule_tab === 2) {
        this.type_all = 'week';
        this.dialogDate_all = false;
      }
    },
    getIntervalCount(value) {
      let count = 19;
      if (value === 0) {
        count = 11;
      }
      if (value === 1) {
        count = 8;
      }
      return count
    },
    filterHistory(){

      //console.log(this.groupLessonFilter)
      //console.log(this.indivLessonFilter)

      ////console.log('--------')
      ////console.log(this.events_def)
      ////console.log(this.clientEvents_def)
      ////console.log(this.allEvents_def)

      if (this.schedule_tab === 0) {

      if (this.groupLessonFilter.specialist && this.groupLessonFilter.specialist.length > 0) {

            this.events = this.events_def.filter((item) => this.groupLessonFilter.specialist.includes(item.specialist_id));

            if (this.toggle_category === 0 || this.toggle_category === 2) {

              let categories = [];
              for (let item of this.events) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.specialist_id
                  })
                }
              }
              this.categories = categories;

            } else {
                  for (let item of this.events) {
                    item.category = item.room_name
                  }
          
                  let categories = [];
                  for (let item of this.events) {
                    let searchObject = categories.find((category) => category.text === item.category);
                    if(searchObject === undefined) {
                      categories.push({
                        text: item.category,
                        value: item.room_id
                      })
                    }
                  }
                  this.categories = categories;
            }

      }
      if (this.groupLessonFilter.position !== null && this.groupLessonFilter.position.length > 0) {

        this.events = this.events_def.filter((item) => item.post_id === this.groupLessonFilter.position);

        if (this.toggle_category_all === 1) {

          let categories = [];
              for (let item of this.events) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.room_id
                  })
                }
              }
              this.categories = categories;
          } else {
            let categories = [];
                for (let item of this.events) {
                  let searchObject = categories.find((category) => category.text === item.category);
                  if(searchObject === undefined) {
                    categories.push({
                      text: item.category,
                      value: item.specialist_id
                    })
                  }
                }
                this.categories = categories;
          }
        }

        if (this.groupLessonFilter.room !== null) {

          this.events = this.events_def.filter((item) => (this.groupLessonFilter.room.includes(item.room_id) || this.groupLessonFilter.room.includes(item.room_name)));

            if (this.toggle_category_all === 1) {
                for (let item of  this.events) {
                  item.category = item.room_name
                }
                let categories = [];
                for (let item of this.events) {
                  let searchObject = categories.find((category) => category.text === item.category);
                  if(searchObject === undefined) {
                    categories.push({
                      text: item.category,
                      value: item.room_id
                    })
                  }
                }
                this.categories = categories;

              } else {
                let categories = [];
                for (let item of this.events) {
                  let searchObject = categories.find((category) => category.text === item.category);
                  if(searchObject === undefined) {
                    categories.push({
                      text: item.category,
                      value: item.specialist_id
                    })
                  }
                }
                this.categories = categories;
              }
          }

          if (this.groupLessonFilter.select_client !== null) {
            this.events = this.events_def.filter((item) => {
              for (let client of item.client_list) {
                return client.client_id === lesson.select_client
              }
            });
          }

          if (this.groupLessonFilter.service !== null) {

            this.events = this.events_def.filter((item) => item.service_id === this.groupLessonFilter.service);

            if (this.toggle_category_all === 0) {
              
                let categories = [];
                ////////console.log(this.events)
                for (let item of this.events) {
                  let searchObject = categories.find((category) => category.text === item.category);
                  if(searchObject === undefined) {
                    categories.push({
                      text: item.category,
                      value: item.specialist_id
                    })
                  }
                }
                this.categories = categories;
            } else {

                for (let item of  this.events) {
                  item.category = item.room_name
                }

                let categories = [];
                for (let item of this.events) {
                  let searchObject = categories.find((category) => category.text === item.category);
                  if(searchObject === undefined) {
                    categories.push({
                      text: item.category,
                      value: item.room_id
                    })
                  }
                }
                this.categories = categories;
            }
          }

          if (this.groupLessonFilter.status !== null) {

              if(this.toggle_category !== 2){
                  this.events = this.events_def.filter((item) => item.status === this.groupLessonFilter.status);
                } else {
                  this.events = this.events_def.filter((item) => item.post_id === this.groupLessonFilter.position);
                }

                let categories = [];
                ////////console.log(this.events)
                for (let item of this.events) {
                  let searchObject = categories.find((category) => category.text === item.category);
                  if(searchObject === undefined) {
                    categories.push({
                      text: item.category,
                      value: item.specialist_id
                    })
                  }
                }
                this.categories = categories;
          }

      } else if(this.schedule_tab === 1) {



        if (this.indivLessonFilter.specialist && this.indivLessonFilter.specialist.length > 0) {

              this.clientEvents = this.clientEvents_def.filter((item) => this.indivLessonFilter.specialist.includes(item.specialist_id));

              if (this.toggle_category === 0 || this.toggle_category === 2) {

                let categories = [];
                for (let item of this.clientEvents) {
                  let searchObject = categories.find((category) => category.text === item.category);
                  if(searchObject === undefined) {
                    categories.push({
                      text: item.category,
                      value: item.specialist_id
                    })
                  }
                }
                this.categories = categories;

              } else {
                    for (let item of this.clientEvents) {
                      item.category = item.room_name
                    }
            
                    let categories = [];
                    for (let item of this.clientEvents) {
                      let searchObject = categories.find((category) => category.text === item.category);
                      if(searchObject === undefined) {
                        categories.push({
                          text: item.category,
                          value: item.room_id
                        })
                      }
                    }
                    this.categories = categories;
              }

        }
        if (this.indivLessonFilter.position !== null && this.indivLessonFilter.position.length > 0) {

        this.clientEvents = this.clientEvents_def.filter((item) => item.post_id === this.indivLessonFilter.position);

         if (this.toggle_category_all === 1) {

          let categories = [];
              for (let item of this.clientEvents) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.room_id
                  })
                }
              }
              this.categories = categories;
          } else {
            let categories = [];
                for (let item of this.clientEvents) {
                  let searchObject = categories.find((category) => category.text === item.category);
                  if(searchObject === undefined) {
                    categories.push({
                      text: item.category,
                      value: item.specialist_id
                    })
                  }
                }
                this.categories = categories;
          }
        }

        if (this.indivLessonFilter.room !== null) {

          this.clientEvents = this.clientEvents_def.filter((item) => (this.indivLessonFilter.room.includes(item.room_id) || this.indivLessonFilter.room.includes(item.room_name)));

            if (this.toggle_category_all === 1) {
                for (let item of  this.clientEvents) {
                  item.category = item.room_name
                }
                let categories = [];
                for (let item of this.clientEvents) {
                  let searchObject = categories.find((category) => category.text === item.category);
                  if(searchObject === undefined) {
                    categories.push({
                      text: item.category,
                      value: item.room_id
                    })
                  }
                }
                this.categories = categories;

              } else {
                let categories = [];
                for (let item of this.clientEvents) {
                  let searchObject = categories.find((category) => category.text === item.category);
                  if(searchObject === undefined) {
                    categories.push({
                      text: item.category,
                      value: item.specialist_id
                    })
                  }
                }
                this.categories = categories;
              }
          }

          if (this.indivLessonFilter.select_client !== null) {
            this.clientEvents = this.clientEvents_def.filter((item) => {
              for (let client of item.client_list) {
                return client.client_id === lesson.select_client
              }
            });
          }

          if (this.indivLessonFilter.service !== null) {

            this.clientEvents = this.clientEvents_def.filter((item) => item.service_id === this.indivLessonFilter.service);

            if (this.toggle_category_all === 0) {
              
                let categories = [];
                ////////console.log(this.events)
                for (let item of this.clientEvents) {
                  let searchObject = categories.find((category) => category.text === item.category);
                  if(searchObject === undefined) {
                    categories.push({
                      text: item.category,
                      value: item.specialist_id
                    })
                  }
                }
                this.categories = categories;
            } else {

                for (let item of  this.clientEvents) {
                  item.category = item.room_name
                }

                let categories = [];
                for (let item of this.clientEvents) {
                  let searchObject = categories.find((category) => category.text === item.category);
                  if(searchObject === undefined) {
                    categories.push({
                      text: item.category,
                      value: item.room_id
                    })
                  }
                }
                this.categories = categories;
            }
          }

          if (this.indivLessonFilter.status !== null) {

              if(this.toggle_category !== 2){
                  this.clientEvents = this.clientEvents_def.filter((item) => item.status === this.indivLessonFilter.status);
                } else {
                  this.clientEvents = this.clientEvents_def.filter((item) => item.post_id === this.indivLessonFilter.position);
                }

                let categories = [];
                ////////console.log(this.events)
                for (let item of this.clientEvents) {
                  let searchObject = categories.find((category) => category.text === item.category);
                  if(searchObject === undefined) {
                    categories.push({
                      text: item.category,
                      value: item.specialist_id
                    })
                  }
                }
                this.categories = categories;
          }

      } else {
        if (this.allLessonFilter.specialist && this.allLessonFilter.specialist.length > 0) {

              this.allEvents = this.allEvents_def.filter((item) => this.allLessonFilter.specialist.includes(item.specialist_id));

              if (this.toggle_category === 0 || this.toggle_category === 2) {

                let categories = [];
                for (let item of this.allEvents) {
                  let searchObject = categories.find((category) => category.text === item.category);
                  if(searchObject === undefined) {
                    categories.push({
                      text: item.category,
                      value: item.specialist_id
                    })
                  }
                }
                this.categoriesAllEvents = categories;

              } else {
                    for (let item of this.allEvents) {
                      item.category = item.room_name
                    }
            
                    let categories = [];
                    for (let item of this.allEvents) {
                      let searchObject = categories.find((category) => category.text === item.category);
                      if(searchObject === undefined) {
                        categories.push({
                          text: item.category,
                          value: item.room_id
                        })
                      }
                    }
                    this.categoriesAllEvents = categories;
              }

        }

        if (this.allLessonFilter.lesson !== null) {
          this.allEvents = this.allEvents_def.filter((item) => item.lesson_type === this.allLessonFilter.lesson);

          if (this.toggle_category_all === 0) {
            let categories = [];
              for (let item of this.allEvents) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.specialist_id
                  })
                }
              }
              this.categoriesAllEvents = categories;
          } else {

            let categories = [];

            for (let item of  this.allEvents) {
                item.category = item.room_name
              }
              
              for (let item of this.allEvents) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.room_id
                  })
                }
              }
              this.categoriesAllEvents = categories;
          }

        }

        if (this.allLessonFilter.position !== null && this.allLessonFilter.position.length > 0) {

        this.allEvents = this.allEvents_def.filter((item) => item.post_id === this.allLessonFilter.position);

         if (this.toggle_category_all === 1) {

          let categories = [];
              for (let item of this.allEvents) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.room_id
                  })
                }
              }
              this.categoriesAllEvents = categories;
          } else {
            let categories = [];
                for (let item of this.allEvents) {
                  let searchObject = categories.find((category) => category.text === item.category);
                  if(searchObject === undefined) {
                    categories.push({
                      text: item.category,
                      value: item.specialist_id
                    })
                  }
                }
                this.categoriesAllEvents = categories;
          }
        }

        if (this.allLessonFilter.room !== null) {

          this.allEvents = this.allEvents_def.filter((item) => (this.allLessonFilter.room.includes(item.room_id) || this.allLessonFilter.room.includes(item.room_name)));

            if (this.toggle_category_all === 1) {
                for (let item of  this.allEvents) {
                  item.category = item.room_name
                }
                let categories = [];
                for (let item of this.allEvents) {
                  let searchObject = categories.find((category) => category.text === item.category);
                  if(searchObject === undefined) {
                    categories.push({
                      text: item.category,
                      value: item.room_id
                    })
                  }
                }
                this.categoriesAllEvents = categories;

              } else {
                let categories = [];
                for (let item of this.allEvents) {
                  let searchObject = categories.find((category) => category.text === item.category);
                  if(searchObject === undefined) {
                    categories.push({
                      text: item.category,
                      value: item.specialist_id
                    })
                  }
                }
                this.categoriesAllEvents = categories;
              }
          }

          if (this.allLessonFilter.select_client !== null) {
            this.allEvents = this.allEvents_def.filter((item) => {
              for (let client of item.client_list) {
                return client.client_id === lesson.select_client
              }
            });
          }

          if (this.allLessonFilter.service !== null) {

            this.allEvents = this.allEvents_def.filter((item) => item.service_id === this.allLessonFilter.service);

            if (this.toggle_category_all === 0) {
              
                let categories = [];
                ////////console.log(this.events)
                for (let item of this.allEvents) {
                  let searchObject = categories.find((category) => category.text === item.category);
                  if(searchObject === undefined) {
                    categories.push({
                      text: item.category,
                      value: item.specialist_id
                    })
                  }
                }
                this.categoriesAllEvents = categories;
            } else {

                for (let item of  this.allEvents) {
                  item.category = item.room_name
                }

                let categories = [];
                for (let item of this.allEvents) {
                  let searchObject = categories.find((category) => category.text === item.category);
                  if(searchObject === undefined) {
                    categories.push({
                      text: item.category,
                      value: item.room_id
                    })
                  }
                }
                this.categoriesAllEvents = categories;
            }
          }

          if (this.allLessonFilter.status !== null) {

              if(this.toggle_category !== 2){
                  this.allEvents = this.allEvents_def.filter((item) => item.status === this.allLessonFilter.status);
                } else {
                  this.allEvents = this.allEvents_def.filter((item) => item.post_id === this.allLessonFilter.position);
                }

                let categories = [];
                ////////console.log(this.events)
                for (let item of this.allEvents) {
                  let searchObject = categories.find((category) => category.text === item.category);
                  if(searchObject === undefined) {
                    categories.push({
                      text: item.category,
                      value: item.specialist_id
                    })
                  }
                }
                this.categoriesAllEvents = categories;
          }
      }

    },
    filterEvents(lesson) {
      ////console.log(lesson)
      ////////console.log(this.type)

      ////console.log(this.events_def)
      ////console.log(this.clientEvents_def)
      ////console.log(this.allEvents_def)

      if(!this.allEvents_def || this.allEvents_def.length === 0){
        this.allEvents_def = this.allEvents
      }

      let s_start_date = this.date
      let s_end_date = this.date

      if(this.type === 'week'){
        s_start_date = this.start.date
        s_end_date = this.end.date
      }

      if (this.schedule_tab === 0) {
        ////////console.log('a1')
        if (lesson.specialist.length > 0) {
          ////////console.log('a2')
          if (this.toggle_category_all === 0) {
            ////////console.log('a3')
            this.$store.dispatch(scheduleActionTypes.getSchedule, {
              start_date: this.dateTable,
              end_date: this.dateTable,
              service_id: this.service ? this.service.service_id : null,
              service_specialist: this.specialist_main ? this.specialist_main : null
            }).then((response) => {

              this.events = response.schedule?.group.filter((item) => lesson.specialist.includes(item.specialist_id));

              let categories = [];
              ////////console.log(this.events)
              for (let item of this.events) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.specialist_id
                  })
                }
              }
              this.categories = categories;
            })
          } else {
            this.$store.dispatch(scheduleActionTypes.getSchedule, {
              start_date: this.dateTable,
              end_date: this.dateTable,
              service_id: this.service ? this.service.service_id : null,
              service_specialist: this.specialist_main ? this.specialist_main : null
            }).then((response) => {
              this.events = response.schedule?.group.filter((item) => lesson.specialist.includes(item.specialist_id));

              for (let item of  this.events) {
                item.category = item.room_name
              }
              let categories = [];
              for (let item of this.events) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.room_id
                  })
                }
              }
              this.categories = categories;
            })

          }
        }
        if (lesson.position !== null) {

          ////console.log(this.categories)

          this.$store.dispatch(scheduleActionTypes.getSchedule, {
              start_date: this.dateTable,
              end_date: this.dateTable,
              service_id: this.service ? this.service.service_id : null,
              service_specialist: this.specialist_main ? this.specialist_main : null
            }).then((response) => {
              this.events = response.schedule?.group.filter((item) => item.post_id === lesson.position);


              if (this.toggle_category_all === 1) {

              let categories = [];
                  for (let item of this.events) {
                    let searchObject = categories.find((category) => category.text === item.category);
                    if(searchObject === undefined) {
                      categories.push({
                        text: item.category,
                        value: item.room_id
                      })
                    }
                  }
                  this.categories = categories;
              } else {
                let categories = [];
                    for (let item of this.events) {
                      let searchObject = categories.find((category) => category.text === item.category);
                      if(searchObject === undefined) {
                        categories.push({
                          text: item.category,
                          value: item.specialist_id
                        })
                      }
                    }
                    this.categories = categories;
              }

              // for (let item of  this.events) {
              //   item.category = item.room_name
              // }
              // let categories = [];
              // for (let item of this.events) {
              //   let searchObject = categories.find((category) => category.text === item.category);
              //   if(searchObject === undefined) {
              //     categories.push({
              //       text: item.category,
              //       value: item.room_id
              //     })
              //   }
              // }
              // this.categories = categories;


              //!!!status
              
              if (lesson.status !== null) {
                  this.events = this.events.filter((item) => item.status === lesson.status);
                  let categories = [];

                  for (let item of this.events) {
                    let searchObject = categories.find((category) => category.text === item.category);
                    if(searchObject === undefined) {
                      categories.push({
                        text: item.category,
                        value: item.specialist_id
                      })
                    }
                  }
                  this.categories = categories;
              }

              //!status
              
            })

    
        }
        if (lesson.room !== null) {
          if (this.toggle_category_all === 1) {
            this.$store.dispatch(scheduleActionTypes.getSchedule, {
              start_date: this.dateTable,
              end_date: this.dateTable,
              service_id: this.service ? this.service.service_id : null,
              service_specialist: this.specialist_main ? this.specialist_main : null
            }).then((response) => {
              this.events = response.schedule?.group.filter((item) => (lesson.room.includes(item.room_id) || lesson.room.includes(item.room_name)));
              for (let item of  this.events) {
                item.category = item.room_name
              }
              let categories = [];
              for (let item of this.events) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.room_id
                  })
                }
              }
              this.categories = categories;
            })
          } else {
            this.$store.dispatch(scheduleActionTypes.getSchedule, {
              start_date: this.dateTable,
              end_date: this.dateTable,
              service_id: this.service ? this.service.service_id : null,
              service_specialist: this.specialist_main ? this.specialist_main : null
            }).then((response) => {
            this.events = response.schedule?.group.filter((item) => (lesson.room.includes(item.room_id) || lesson.room.includes(item.room_name)));
            let categories = [];
              for (let item of this.events) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.specialist_id
                  })
                }
              }
              this.categories = categories;
            })
          }
        }
        if (lesson.select_client !== null) {
          this.events = this.events_def.filter((item) => {
            for (let client of item.client_list) {
              return client.client_id === lesson.select_client
            }
          });
        }
        if (lesson.service !== null) {
        //this.events = this.events.filter((item) => item.service_id === lesson.service);
          ////////console.log(this.toggle_category)
          ////////console.log(this.toggle_category_all)
          if (this.toggle_category_all === 0) {
            ////////console.log('a3')
            this.$store.dispatch(scheduleActionTypes.getSchedule, {
              start_date: this.dateTable,
              end_date: this.dateTable,
              service_id: this.service ? this.service.service_id : null,
              service_specialist: this.specialist_main ? this.specialist_main : null
            }).then((response) => {
              this.events = response.schedule?.group.filter((item) => item.service_id === lesson.service);

              let categories = [];
              ////////console.log(this.events)
              for (let item of this.events) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.specialist_id
                  })
                }
              }
              this.categories = categories;
            })
          } else {

            ////////console.log('a3')
            this.$store.dispatch(scheduleActionTypes.getSchedule, {
              start_date: this.dateTable,
              end_date: this.dateTable,
              service_id: this.service ? this.service.service_id : null,
              service_specialist: this.specialist_main ? this.specialist_main : null
            }).then((response) => {
              this.events = response.schedule?.group.filter((item) => item.service_id === lesson.service);

              for (let item of  this.events) {
                item.category = item.room_name
              }
              let categories = [];
              for (let item of this.events) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.room_id
                  })
                }
              }
              this.categories = categories;
            })
          }
        }
        if (lesson.status !== null) {
          this.events = this.events_def.filter((item) => item.status === lesson.status);

          this.$store.dispatch(scheduleActionTypes.getSchedule, {
              start_date: this.dateTable,
              end_date: this.dateTable,
              service_id: this.service ? this.service.service_id : null,
              service_specialist: this.specialist_main ? this.specialist_main : null
            }).then((response) => {

        
              if(this.toggle_category !== 2){
                this.events = response.schedule?.group.filter((item) => item.status === lesson.status);
              } else {
                this.events = this.events.filter((item) => item.post_id === lesson.position);
              }

              let categories = [];
              ////////console.log(this.events)
              for (let item of this.events) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.specialist_id
                  })
                }
              }
              this.categories = categories;

            });

        }
      }
      if (this.schedule_tab === 1) {

        if (lesson.specialist.length > 0) {
          if (this.toggle_category === 0 || this.toggle_category === 2) {
            this.$store.dispatch(scheduleActionTypes.getSchedule, {
              start_date: this.dateTable,
              end_date: this.dateTable,
              service_id: this.service ? this.service.service_id : null,
              service_specialist: this.specialist_main ? this.specialist_main : null
            }).then((response) => {
              if(this.toggle_category !== 2){
                this.clientEvents = response.schedule?.indiv.filter((item) => lesson.specialist.includes(item.specialist_id));
                this.events = response.schedule?.group.filter((item) => lesson.specialist.includes(item.specialist_id));
                let categories = [];
                for (let item of this.clientEvents) {
                  let searchObject = categories.find((category) => category.text === item.category);
                  if(searchObject === undefined) {
                    categories.push({
                      text: item.category,
                      value: item.specialist_id
                    })
                  }
                }

                this.categories = categories;

              } else {
                this.events = response.schedule?.group.filter((item) => lesson.specialist.includes(item.specialist_id));
                this.clientEvents = response.schedule?.indiv.filter((item) => lesson.specialist.includes(item.specialist_id));
                let categories = [];
                for (let item of this.clientEvents) {
                  let searchObject = categories.find((category) => category.text === item.category);
                  if(searchObject === undefined) {
                    categories.push({
                      text: item.category,
                      value: item.specialist_id
                    })
                  }
                }
                this.categories = categories;
              }
            })
          } else {

            this.$store.dispatch(scheduleActionTypes.getSchedule, {
              start_date: this.dateTable,
              end_date: this.dateTable,
              service_id: this.service ? this.service.service_id : null,
              service_specialist: this.specialist_main ? this.specialist_main : null
            }).then((response) => {

            ////////console.log('elseee')
            
            this.clientEvents = response.schedule?.indiv.filter((item) => lesson.specialist.includes(item.specialist_id));

            for (let item of this.clientEvents) {
              item.category = item.room_name
            }
      
              let categories = [];
              for (let item of this.clientEvents) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.room_id
                  })
                }
              }
              this.categories = categories;

              })
          }
        }
        if (lesson.position !== null) {

          
          this.$store.dispatch(scheduleActionTypes.getSchedule, {
              start_date: this.dateTable,
              end_date: this.dateTable,
              service_id: this.service ? this.service.service_id : null,
              service_specialist: this.specialist_main ? this.specialist_main : null
            }).then((response) => {

          if(this.toggle_category !== 2){


            this.clientEvents = response.schedule?.indiv.filter((item) => item.post_id === lesson.position);

            if (this.toggle_category_all === 1) {

                let categories = [];
                    for (let item of this.clientEvents) {
                      let searchObject = categories.find((category) => category.text === item.category);
                      if(searchObject === undefined) {
                        categories.push({
                          text: item.category,
                          value: item.room_id
                        })
                      }
                    }
                    this.categories = categories;
                } else {
                  let categories = [];
                      for (let item of this.clientEvents) {
                        let searchObject = categories.find((category) => category.text === item.category);
                        if(searchObject === undefined) {
                          categories.push({
                            text: item.category,
                            value: item.specialist_id
                          })
                        }
                      }
                      this.categories = categories;
                }

            } else {
               this.clientEvents = this.clientEvents_def.filter((item) => item.post_id === lesson.position);

              let categories = [];
                  for (let item of this.clientEvents) {
                    let searchObject = categories.find((category) => category.text === item.category);
                    if(searchObject === undefined) {
                      categories.push({
                        text: item.category,
                        value: item.room_id
                      })
                    }
                  }
                  this.categories = categories;
            }


            //!!!status

            if (lesson.status !== null) {
                this.clientEvents = this.clientEvents.filter((item) => item.status === lesson.status);
                let categories = [];

                for (let item of this.clientEvents) {
                  let searchObject = categories.find((category) => category.text === item.category);
                  if(searchObject === undefined) {
                    categories.push({
                      text: item.category,
                      value: item.specialist_id
                    })
                  }
                }
                this.categories = categories;
            }

            //!status

          })
              
        }
        if (lesson.room !== null) {


          if (this.toggle_category_all === 1) {
            this.$store.dispatch(scheduleActionTypes.getSchedule, {
              start_date: this.dateTable,
              end_date: this.dateTable,
              service_id: this.service ? this.service.service_id : null,
              service_specialist: this.specialist_main ? this.specialist_main : null
            }).then((response) => {
           
              this.clientEvents = response.schedule?.indiv.filter((item) => (lesson.room.includes(item.room_id) || lesson.room.includes(item.room_name)));
              for (let item of  this.clientEvents) {
                item.category = item.room_name
              }
              let categories = [];
              for (let item of this.clientEvents) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.room_id
                  })
                }
              }
              this.categories = categories;

            })
          } else {
            this.$store.dispatch(scheduleActionTypes.getSchedule, {
              start_date: this.dateTable,
              end_date: this.dateTable,
              service_id: this.service ? this.service.service_id : null,
              service_specialist: this.specialist_main ? this.specialist_main : null
            }).then((response) => {
            this.clientEvents = response.schedule?.indiv.filter((item) => (lesson.room.includes(item.room_id) || lesson.room.includes(item.room_name)));
            let categories = [];
              for (let item of this.clientEvents) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.specialist_id
                  })
                }
              }
              this.categories = categories;
            })
          }

          // if (this.toggle_category === 1) {
          //   this.$store.dispatch(scheduleActionTypes.getSchedule, {
          //     start_date: this.dateTable,
          //     end_date: this.dateTable,
          //     service_id: this.service ? this.service.service_id : null,
          //     service_specialist: this.specialist_main ? this.specialist_main : null
          //   }).then((response) => {
          //     this.clientEvents = response.schedule?.indiv.filter((item) => (lesson.room.includes(item.room_id) || lesson.room.includes(item.room_name)));
          //     for (let item of  this.clientEvents) {
          //       item.category = item.room_name
          //     }
          //     let categories = [];
          //     for (let item of this.clientEvents) {
          //       let searchObject = categories.find((category) => category.text === item.category);
          //       if(searchObject === undefined) {
          //         categories.push({
          //           text: item.category,
          //           value: item.room_id
          //         })
          //       }
          //     }
          //     this.categories = categories;
          //   })
          // } else {
          //   this.clientEvents = this.clientEvents.filter((item) => lesson.room.includes(item.room_id));
          // }

        }
        if (lesson.select_client !== null) {
          this.clientEvents = this.clientEvents_def.filter((item) => {
            for (let client of item.client_list) {
              return client.client_id === lesson.select_client
            }
          });
        }
        if (lesson.service !== null) {
        //this.events = this.events.filter((item) => item.service_id === lesson.service);
          ////////console.log(this.toggle_category)
          ////////console.log(this.toggle_category_all)
          if (this.toggle_category_all === 0) {
            ////////console.log('a3')
            this.$store.dispatch(scheduleActionTypes.getSchedule, {
              start_date: this.dateTable,
              end_date: this.dateTable,
              service_id: this.service ? this.service.service_id : null,
              service_specialist: this.specialist_main ? this.specialist_main : null
            }).then((response) => {
              this.clientEvents = response.schedule?.indiv.filter((item) => item.service_id === lesson.service);

              let categories = [];
              for (let item of this.clientEvents) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.specialist_id
                  })
                }
              }
              this.categories = categories;
            })
          } else {

            this.$store.dispatch(scheduleActionTypes.getSchedule, {
              start_date: this.dateTable,
              end_date: this.dateTable,
              service_id: this.service ? this.service.service_id : null,
              service_specialist: this.specialist_main ? this.specialist_main : null
            }).then((response) => {
              this.clientEvents = response.schedule?.indiv.filter((item) => item.service_id === lesson.service);

              for (let item of  this.clientEvents) {
                item.category = item.room_name
              }
              let categories = [];
              for (let item of this.clientEvents) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.room_id
                  })
                }
              }
              this.categories = categories;
            })
          }
        }
        if (lesson.status !== null) {

          this.$store.dispatch(scheduleActionTypes.getSchedule, {
              start_date: this.dateTable,
              end_date: this.dateTable,
              service_id: this.service ? this.service.service_id : null,
              service_specialist: this.specialist_main ? this.specialist_main : null
            }).then((response) => {

              if(this.toggle_category !== 2){
                this.clientEvents = response.schedule?.indiv.filter((item) => item.status === lesson.status);
              } else {
                this.events = this.events.filter((item) => item.post_id === lesson.position);
              }

              let categories = [];

              for (let item of this.clientEvents) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.specialist_id
                  })
                }
              }
              this.categories = categories;


            });

   
        }

      }
      if (this.schedule_tab === 2) {
        ////console.log(lesson)
        if (lesson.lesson !== null) {
          this.allEvents = this.allEvents_def.filter((item) => item.lesson_type === lesson.lesson);

          if (this.toggle_category_all === 0) {
            let categories = [];
              for (let item of this.allEvents) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.specialist_id
                  })
                }
              }
              this.categoriesAllEvents = categories;
          } else {

            let categories = [];

            for (let item of  this.allEvents) {
                item.category = item.room_name
              }
              
              for (let item of this.allEvents) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.room_id
                  })
                }
              }
              this.categoriesAllEvents = categories;
          }

        }
        if (lesson.specialist.length > 0) {
          ////////console.log('a2')
          if (this.toggle_category_all === 0) {
            ////////console.log('a3')
            this.$store.dispatch(scheduleActionTypes.getSchedule, {
              start_date: this.dateTable,
              end_date: this.dateTable,
              service_id: this.service ? this.service.service_id : null,
              service_specialist: this.specialist_main ? this.specialist_main : null
            }).then((response) => {

              this.allEvents = response.schedule?.all.filter((item) => lesson.specialist.includes(item.specialist_id));
              let categories = [];
              for (let item of this.allEvents) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.specialist_id
                  })
                }
              }
              this.categoriesAllEvents = categories;
            })
          } else {
            this.$store.dispatch(scheduleActionTypes.getSchedule, {
              start_date: this.dateTable,
              end_date: this.dateTable,
              service_id: this.service ? this.service.service_id : null,
              service_specialist: this.specialist_main ? this.specialist_main : null
            }).then((response) => {
              this.allEvents = response.schedule?.all.filter((item) => lesson.specialist.includes(item.specialist_id));

              for (let item of  this.allEvents) {
                item.category = item.room_name
              }
              let categories = [];
              for (let item of this.allEvents) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.room_id
                  })
                }
              }
              this.categoriesAllEvents = categories;
            })

          }
        }
        if (lesson.position !== null) {

          this.$store.dispatch(scheduleActionTypes.getSchedule, {
              start_date: this.dateTable,
              end_date: this.dateTable,
              service_id: this.service ? this.service.service_id : null,
              service_specialist: this.specialist_main ? this.specialist_main : null
            }).then((response) => {
              this.allEvents = response.schedule?.all.filter((item) => item.post_id === lesson.position);

              
            if (this.toggle_category_all === 1) {

                let categories = [];
                    for (let item of this.allEvents) {
                      let searchObject = categories.find((category) => category.text === item.category);
                      if(searchObject === undefined) {
                        categories.push({
                          text: item.category,
                          value: item.room_id
                        })
                      }
                    }
                    this.categoriesAllEvents = categories;
                } else {
                  let categories = [];
                      for (let item of this.allEvents) {
                        let searchObject = categories.find((category) => category.text === item.category);
                        if(searchObject === undefined) {
                          categories.push({
                            text: item.category,
                            value: item.specialist_id
                          })
                        }
                      }
                      this.categoriesAllEvents = categories;
                }
            })

        }
        if (lesson.room !== null) {
          if (this.toggle_category_all === 1) {
            this.$store.dispatch(scheduleActionTypes.getSchedule, {
              start_date: this.dateTable,
              end_date: this.dateTable,
              service_id: this.service ? this.service.service_id : null,
              service_specialist: this.specialist_main ? this.specialist_main : null
            }).then((response) => {
              this.allEvents = response.schedule?.all.filter((item) => (lesson.room.includes(item.room_id) || lesson.room.includes(item.room_name)));
              for (let item of  this.allEvents) {
                item.category = item.room_name
              }
              let categories = [];
              for (let item of this.allEvents) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.room_id
                  })
                }
              }
              this.categoriesAllEvents = categories;
            })
          } else {
            this.$store.dispatch(scheduleActionTypes.getSchedule, {
              start_date: this.dateTable,
              end_date: this.dateTable,
              service_id: this.service ? this.service.service_id : null,
              service_specialist: this.specialist_main ? this.specialist_main : null
            }).then((response) => {
            this.allEvents = response.schedule?.all.filter((item) => (lesson.room.includes(item.room_id) || lesson.room.includes(item.room_name)));
            let categories = [];
              for (let item of this.allEvents) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.specialist_id
                  })
                }
              }
              this.categoriesAllEvents = categories;
            })
          }
        }
        if (lesson.select_client !== null) {
          this.allEvents = this.allEvents_def.filter((item) => {
            for (let client of item.client_list) {
              return client.client_id === lesson.select_client
            }
          });
        }
        if (lesson.service !== null) {
       
          if (this.toggle_category_all === 0) {
            ////////console.log('a3')
            this.$store.dispatch(scheduleActionTypes.getSchedule, {
              start_date: this.dateTable,
              end_date: this.dateTable,
              service_id: this.service ? this.service.service_id : null,
              service_specialist: this.specialist_main ? this.specialist_main : null
            }).then((response) => {
              this.allEvents = response.schedule?.all.filter((item) => item.service_id === lesson.service);

              let categories = [];
              ////////console.log(this.events)
              for (let item of this.allEvents) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.specialist_id
                  })
                }
              }
              this.categoriesAllEvents = categories;
            })
          } else {

            ////////console.log('a3')
            this.$store.dispatch(scheduleActionTypes.getSchedule, {
              start_date: this.dateTable,
              end_date: this.dateTable,
              service_id: this.service ? this.service.service_id : null,
              service_specialist: this.specialist_main ? this.specialist_main : null
            }).then((response) => {
              this.allEvents = response.schedule?.all.filter((item) => item.service_id === lesson.service);

              for (let item of  this.allEvents) {
                item.category = item.room_name
              }
              let categories = [];
              for (let item of this.allEvents) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.room_id
                  })
                }
              }
              this.categoriesAllEvents = categories;
            })
          }
        }
        if (lesson.status !== null) {
          this.allEvents = this.allEvents_def.filter((item) => item.status === lesson.status);

          this.$store.dispatch(scheduleActionTypes.getSchedule, {
              start_date: this.dateTable,
              end_date: this.dateTable,
              service_id: this.service ? this.service.service_id : null,
              service_specialist: this.specialist_main ? this.specialist_main : null
            }).then((response) => {

        
              if(this.toggle_category !== 2){
                this.allEvents = response.schedule?.all.filter((item) => item.status === lesson.status);
              } else {
                this.allEvents = this.allEvents.filter((item) => item.post_id === lesson.position);
              }

              let categories = [];
              ////////console.log(this.events)
              for (let item of this.allEvents) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.specialist_id
                  })
                }
              }
              this.categoriesAllEvents = categories;

            });

        }
      }
    }
  },
  watch: {
    'groupLessonFilter.search_client'() {
      if (this.groupLessonFilter.search_client !== '') {
        this.$store.dispatch(clientActionTypes.searchClient, {
          client_field: this.groupLessonFilter.search_client
        })
      }
    },
    'indivLessonFilter.search_client'() {
      ////////console.log('indiv watch')
      if (this.indivLessonFilter.search_client !== '') {
        this.$store.dispatch(clientActionTypes.searchClient, {
          client_field: this.indivLessonFilter.search_client
        })
      }
    },
    'allLessonFilter.search_client'() {
      if (this.allLessonFilter.search_client !== '') {
        this.$store.dispatch(clientActionTypes.searchClient, {
          client_field: this.allLessonFilter.search_client
        })
      }
    },
    toggle_category() {
      
      

      setItem('toggle_category',this.toggle_category)
      setItem('toggle_category_all',null)

      if (this.toggle_category === 0) {

        ////console.log('ffff00')
        
        this.$store.dispatch(scheduleActionTypes.getSchedule, {
          start_date: this.start.date,
          end_date: this.end.date,
          service_id: this.service ? this.service.service_id : null,
          service_specialist: this.specialist_main ? this.specialist_main : null
        }).then((response) => {
          this.events = response.schedule?.group
          this.clientEvents = response.schedule?.indiv
          this.allEvents = response.schedule?.all

          if (this.schedule_tab === 0) {

            

            let categories = [];
            for (let item of this.events) {
              let searchObject = categories.find((category) => category.text === item.category);
              if(searchObject === undefined) {
                categories.push({
                  text: item.category,
                  value: item.specialist_id
                })
              }
            }
            this.categories = categories;

            this.events_def = this.events
            this.filterHistory()

          } else if (this.schedule_tab === 1) {

           let categories = [];
            for (let item of this.clientEvents) {
              let searchObject = categories.find((category) => category.text === item.category);
              if(searchObject === undefined) {
                categories.push({
                  text: item.category,
                  value: item.specialist_id
                })
              }
            }
            this.categories = categories;

            this.clientEvents_def = this.clientEvents
            this.filterHistory()

          } else {            
            let categories = [];
            for (let item of this.allEvents) {
              let searchObject = categories.find((category) => category.text === item.category);
              if(searchObject === undefined) {
                categories.push({
                  text: item.category,
                  value: item.specialist_id
                })
              }
            }
            this.categoriesAllEvents = categories;

            this.allEvents_def = this.allEvents
            this.filterHistory()

          }

          
  

         
        })
      } else if (this.toggle_category === 1){

        ////////console.log('ffff')
        ////////console.log(this.start.date)
        ////////console.log(this.end.date)
        
        
        this.$store.dispatch(scheduleActionTypes.getSchedule, {
          start_date: this.start.date,
          end_date: this.end.date,
          service_id: this.service ? this.service.service_id : null,
          service_specialist: this.specialist_main ? this.specialist_main : null
        }).then((response) => {
          if (response.success) {

            this.events = response.schedule?.group
            this.clientEvents = response.schedule?.indiv
            this.allEvents = response.schedule?.all

      
            
            this.$store.dispatch(lessonActionTypes.getRoomList, {
              for_lesson: true
            })
                .then((response) => {
                  if (response.success) {

                    // if (this.schedule_tab === 1) {
                    //   for (let item of response.schedule?.indiv) {
                    //     item.category = item.room_name
                    //   }
                    // } else if (this.schedule_tab === 0) {
                    //   for (let item of response.schedule?.indiv) {
                    //     item.category = item.room_name
                    //   }
                    // } else {
                    //   for (let item of response.schedule?.group) {
                    //     item.category = item.room_name
                    //   }
                    //   this.clientEvents = response.schedule?.group

                    // }

                    if (this.schedule_tab === 2) {
                      let categories = [];
                    
                      for (let item of response.room) {
                        let searchObject = categories.find((category) => category.text === item.name);
                        if(searchObject === undefined) {
                          categories.push({
                            text: item.name,
                            value: item.id
                          })
                        }
                      }
                      this.categoriesAllEvents = categories;

                    } else {
                      let categories = [];
                    
                      for (let item of response.room) {
                        let searchObject = categories.find((category) => category.text === item.name);
                        if(searchObject === undefined) {
                          categories.push({
                            text: item.name,
                            value: item.id
                          })
                        }
                      }
                      ////////console.log(categories)
                      this.categories = categories;
                    }
                    
                  }
                });


                this.clientEvents_def = this.clientEvents
              this.events_def = this.events
              this.allEvents_def = this.allEvents
              this.filterHistory()
         
          }
        })
      } else {
        
        this.type = 'week'
        this.$store.dispatch(scheduleActionTypes.getSchedule, {
          start_date: this.start.date,
          end_date: this.end.date,
          service_id: this.service ? this.service.service_id : null,
          service_specialist: this.specialist_main ? this.specialist_main : null
        }).then((response) => {
          this.clientEvents = response.schedule?.indiv
          let categories = [];
          for (let item of this.clientEvents) {
            let searchObject = categories.find((category) => category.text === item.category);
            if(searchObject === undefined) {
              categories.push({
                text: item.category,
                value: item.specialist_id
              })
            }
          }
          this.categories = categories;
          this.dialogButton_indiv = true
          //this.filterEvents(this.indivLessonFilter)
          ////////console.log(this.specialist_main)

          this.clientEvents_def = this.clientEvents
              this.events_def = this.events
              this.allEvents_def = this.allEvents
              this.filterHistory()
        })
      }

      ////console.log('togle category')


    },
    date() {
      //////console.log('watch date')
      if (this.schedule_tab === 1) {
        this.$store.dispatch(scheduleActionTypes.getSchedule, {
          start_date: this.date,
          end_date: this.date,
          service_id: this.service ? this.service.service_id : null
        }).then((response) => {
          this.clientEvents = response.schedule?.indiv
          let categories = [];
          for (let item of this.clientEvents) {
            let searchObject = categories.find((category) => category.text === item.category);
            if(searchObject === undefined) {
              categories.push({
                text: item.category,
                value: item.specialist_id
              })
            }
          }
          this.categories = categories;
        })
      }
    },
    toggle_category_all() {
      ////////console.log('watch cat')

      setItem('toggle_category_all',this.toggle_category_all)
      setItem('toggle_category',null)

      if (this.toggle_category_all === 0) {
        ////////console.log(this.toggle_category_all)
        ////////console.log('gg')
        this.$store.dispatch(scheduleActionTypes.getSchedule, {
          start_date: this.dateTable,
          end_date: this.dateTable,
          service_id: this.service ? this.service.service_id : null,
          service_specialist: this.specialist_main ? this.specialist_main : null
        }).then((response) => {
          this.allEvents = response.schedule?.all
          this.events = response.schedule?.group
          let categoriesAll = [];
          let categories = [];
          for (let item of this.allEvents) {
            let searchObject = categoriesAll.find((category) => category.text === item.category);
            if(searchObject === undefined) {
              categoriesAll.push({
                text: item.category,
                value: item.specialist_id
              })
            }
          }
          for (let item of this.events) {
            let searchObject = categories.find((category) => category.text === item.category);
            if(searchObject === undefined) {
              categories.push({
                text: item.category,
                value: item.specialist_id
              })
            }
          }
          this.categoriesAllEvents = categoriesAll;
          this.categories = categories;
          // this.$store.dispatch(scheduleActionTypes.getScheduleDuty, {
          //   start_date: this.date_all,
          //   end_date: this.date_all
          // }).then((response) => {
          //   this.dutyEvents = response.duty;
          // })
        })
      } else {
        ////////console.log(this.toggle_category_all)
        ////////console.log('gg11')
        ////////console.log(this.dateTable)
        this.$store.dispatch(scheduleActionTypes.getSchedule, {
          start_date: this.dateTable,
          end_date: this.dateTable,
          service_id: this.service ? this.service.service_id : null,
          service_specialist: this.specialist_main ? this.specialist_main : null
        }).then((response) => {
          if (response.success) {
            for (let item of response.schedule?.all) {
              item.category = item.room_name
            }
            this.allEvents = response.schedule?.all

            for (let item of response.schedule?.group) {
              item.category = item.room_name
            }
            this.events = response.schedule?.group

            this.$store.dispatch(lessonActionTypes.getRoomList, {
              for_lesson: true
            })
                .then((response) => {
                  if (response.success) {
                    let categories = [];
                    let categoriesAll = [];
                    for (let item of response.room) {
                      if(categoriesAll.indexOf(item.name) === -1) {
                        categoriesAll.push(item.name)
                      }
                    }
                    for (let item of response.room) {
                      if(categories.indexOf(item.name) === -1) {
                        categories.push(item.name)
                      }
                    }
                    this.categoriesAllEvents = categoriesAll;
                    this.categories = categories;
                  }
                });
          }
        })
      }
    },
    date_all() {
      ////////console.log('watch all')

      ////console.log('strel22222')
      if (this.schedule_tab === 2) {
        this.$store.dispatch(scheduleActionTypes.getSchedule, {
          start_date: this.date_all,
          end_date: this.date_all,
          service_id: this.service ? this.service.service_id : null,
          service_specialist: this.specialist_main ? this.specialist_main : null
        }).then((response) => {
          if (response.success) {
            if (this.toggle_category_all === 0) {
              this.allEvents = response.schedule?.all
              let categories = [];
              for (let item of this.allEvents) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.specialist_id
                  })
                }
              }
              this.categoriesAllEvents = categories;
              // this.$store.dispatch(scheduleActionTypes.getScheduleDuty, {
              //   start_date: this.date_all,
              //   end_date: this.date_all
              // }).then((response) => {
              //   this.dutyEvents = response.duty;
              // })
            } else {
              for (let item of response.schedule?.all) {
                item.category = item.room_name
              }
              this.allEvents = response.schedule?.all
              this.$store.dispatch(lessonActionTypes.getRoomList, {
                for_lesson: true
              })
                  .then((response) => {
                    if (response.success) {
                      let categories = [];
                      for (let item of response.room) {
                        if(categories.indexOf(item.name) === -1) {
                          categories.push(item.name)
                        }
                      }
                      this.categoriesAllEvents = categories;
                    }
                  });
            }

            this.allEvents_def = this.allEvents
            this.filterHistory()

          }
        })
      }
    },
    schedule_tab() {
      //console.log('watch tab')
      ////////console.log(this.schedule_tab)

      ////////console.log(this.toggle_category)
      ////////console.log(this.toggle_category_all)

      setItem('spec_main',null)

      this.dialogDate = true

      ////console.log(this.toggle_date)

      if (this.schedule_tab === 0) {
        
        ////////console.log('ggadasdasdasd')
        setItem('tog-cat', 0)
        if (this.$refs.groupFilterForm) {
          this.$refs.groupFilterForm.reset();
          this.selected.length = 0;
          this.dialogButton = false;
          this.dialogFiler = false;
        }
        let s_start_date = this.date
          let s_end_date = this.date
        if (this.toggle_date === 0) {
         s_start_date = this.dateTable
         s_end_date = this.dateTable
        }
        if (this.toggle_date === 1 && this.start && this.end) {
         s_start_date = this.start.date
         s_end_date = this.end.date
        }

        if (this.toggle_date === 0) {
          this.type = 'day'
          this.$store.dispatch(scheduleActionTypes.getSchedule, {
            start_date: this.dateTable,
            end_date: this.dateTable,
            service_id: this.service ? this.service.service_id : null,
            service_specialist: this.specialist_main ? this.specialist_main : null
          }).then((response) => {
            //this.events = response.schedule?.group

            if (this.toggle_category_all === 0) {
              this.events = response.schedule?.group
              ////////console.log(this.categories)
              this.categories = []
              let categories = [];
              for (let item of this.events) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.specialist_id
                  })
                  this.categories.push({
                    text: item.category,
                    value: item.specialist_id
                  })
                }
              }

              ////////console.log(categories)

              this.categories = categories;

              if(this.specialist_main && this.specialist_main.id){
                this.groupLessonFilter.specialist.push(this.specialist_main.id)
                this.dialogButton_indiv = true
                this.filterEvents(this.groupLessonFilter)
                ////////console.log(this.specialist_main)
              }

            } else if(this.toggle_category_all === 2){
              ////////console.log('aga')
              if (this.toggle_date === 1 && this.start && this.end) {
                ////////console.log('aga1')
                this.type = 'week'
                this.$store.dispatch(scheduleActionTypes.getSchedule, {
                  start_date: this.start.date,
                  end_date: this.end.date,
                  service_id: this.service ? this.service.service_id : null,
                  service_specialist: this.specialist_main ? this.specialist_main : null
                }).then((response) => {
                  this.events = response.schedule?.group
                })
              } else {

              }
            } else {
              for (let item of response.schedule?.group) {
                item.category = item.room_name
              }
              this.events = response.schedule?.group
              this.$store.dispatch(lessonActionTypes.getRoomList, {
                for_lesson: true
              })
                  .then((response) => {
                    if (response.success) {
                      this.categories = [];
                      let categories = [];
                      for (let item of response.room) {
                        if(categories.indexOf(item.name) === -1) {
                          categories.push(item.name)
                        }
                      }
                      this.categories = categories;
                    }
                  });
            }

         

          })
        }
       if (this.toggle_date === 1 && this.start && this.end) {

             ////console.log('week222')
               this.dialogDate = false
              this.type_all = 'week';
              this.dialogDate_all = false;
              this.type = 'week'
      
          this.type = 'week'
          this.$store.dispatch(scheduleActionTypes.getSchedule, {
            start_date: this.start.date,
            end_date: this.end.date,
            service_id: this.service ? this.service.service_id : null,
            service_specialist: this.specialist_main ? this.specialist_main : null
          }).then((response) => {
            //this.events = response.schedule?.group

            if (this.toggle_category === 0) {

              ////console.log('spec week')

              this.events = response.schedule?.group
              let categories = [];
              for (let item of this.events) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.specialist_id
                  })
                }
              }
              this.categories = categories;

              if(this.specialist_main && this.specialist_main.id){
                this.groupLessonFilter.specialist.push(this.specialist_main.id)
                this.dialogButton_indiv = true
                this.filterEvents(this.groupLessonFilter)
                ////////console.log(this.specialist_main)
              }

            } else if(this.toggle_category === 2){
              ////////console.log('aga')
              if (this.toggle_date === 1 && this.start && this.end) {
                ////////console.log('aga1')
                this.type = 'week'
                this.$store.dispatch(scheduleActionTypes.getSchedule, {
                  start_date: this.start.date,
                  end_date: this.end.date,
                  service_id: this.service ? this.service.service_id : null,
                  service_specialist: this.specialist_main ? this.specialist_main : null
                }).then((response) => {
                  this.clientEvents = response.schedule?.indiv
                })
              } else {

              }
            } else {
              for (let item of response.schedule?.group) {
                item.category = item.room_name
              }
              this.events = response.schedule?.group
              this.$store.dispatch(lessonActionTypes.getRoomList, {
                for_lesson: true
              })
                  .then((response) => {
                    if (response.success) {
                      let categories = [];
                      for (let item of response.room) {
                        if(categories.indexOf(item.name) === -1) {
                          categories.push(item.name)
                        }
                      }
                      this.categories = categories;
                    }
                  });
            }

          })
        } 
      }
      if (this.schedule_tab === 1) {

        ////////console.log(this.dateTable)
        ////////console.log(this.date)
        ////////console.log(this.end)

        ////////console.log('GHHHHH')
        setItem('tog-cat', 1)
        if (this.$refs.indivFilterForm) {
          this.$refs.indivFilterForm.reset();
          this.selected_indiv.length = 0;
          this.dialogButton_indiv = false;
          this.dialogFiler_indiv = false;
        }
          let s_start_date = this.date
          let s_end_date = this.date
        if (this.toggle_date === 0) {
         s_start_date = this.dateTable
         s_end_date = this.dateTable
        }
        if (this.toggle_date === 1 && this.start && this.end) {
         s_start_date = this.start.date
         s_end_date = this.end.date
        }
        ////////console.log('---')
        ////////console.log(this.dateTable)
        ////////console.log(this.date)
        ////////console.log(this.end)

        if(this.service && this.service.service_id){

          ////////console.log(this.service)
          this.$store.dispatch(lessonActionTypes.getSpecialistList, {
            client_id: this.client_id,
            service_id: this.service.service_id
          }).then((resp) => {
            //"48830ace-00d9-11ec-a060-60e32700ce56"
            //this.specialist_list = resp.specialist
            if(resp && resp.specialist){
              for(let i = 0; i < resp.specialist.length; i++) {
                this.specialist_list_def.push(resp.specialist[i].id) 
              }
            }
            
          });
        }
        

        if (this.toggle_date === 0) {
          this.type = 'day'
          this.$store.dispatch(scheduleActionTypes.getSchedule, {
            start_date: this.dateTable,
            end_date: this.dateTable,
            service_id: this.service ? this.service.service_id : null,
            service_specialist: this.specialist_main ? this.specialist_main : null
          }).then((response) => {

            if (this.toggle_category_all === 0) {
              this.clientEvents = response.schedule?.indiv
              ////////console.log(this.categories)
              this.categories = []
              let categories = [];
              for (let item of this.clientEvents) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.specialist_id
                  })
                  this.categories.push({
                    text: item.category,
                    value: item.specialist_id
                  })
                }
              }

              ////////console.log(categories)

              this.categories = categories;

              if(this.specialist_main && this.specialist_main.id){
                this.indivLessonFilter.specialist.push(this.specialist_main.id)
                this.dialogButton_indiv = true
                this.filterEvents(this.indivLessonFilter)
                ////////console.log(this.specialist_main)
              }

            } else if(this.toggle_category_all === 2){
              ////////console.log('aga')
              if (this.toggle_date === 1 && this.start && this.end) {
                ////////console.log('aga1')
                this.type = 'week'
                this.$store.dispatch(scheduleActionTypes.getSchedule, {
                  start_date: this.start.date,
                  end_date: this.end.date,
                  service_id: this.service ? this.service.service_id : null,
                  service_specialist: this.specialist_main ? this.specialist_main : null
                }).then((response) => {
                  this.clientEvents = response.schedule?.indiv
                })
              } else {

              }
            } else {
              for (let item of response.schedule?.indiv) {
                item.category = item.room_name
              }
              this.clientEvents = response.schedule?.indiv
              this.$store.dispatch(lessonActionTypes.getRoomList, {
                for_lesson: true
              })
                  .then((response) => {
                    if (response.success) {
                      this.categories = [];
                      let categories = [];
                      for (let item of response.room) {
                        if(categories.indexOf(item.name) === -1) {
                          categories.push(item.name)
                        }
                      }
                      this.categories = categories;
                    }
                  });
            }

         

          })
        }
       if (this.toggle_date === 1 && this.start && this.end) {

             ////console.log('week222')
               this.dialogDate = false
              this.type_all = 'week';
              this.dialogDate_all = false;
              this.type = 'week'
      
          this.type = 'week'
          this.$store.dispatch(scheduleActionTypes.getSchedule, {
            start_date: this.start.date,
            end_date: this.end.date,
            service_id: this.service ? this.service.service_id : null,
            service_specialist: this.specialist_main ? this.specialist_main : null
          }).then((response) => {

            if (this.toggle_category === 0) {

              ////console.log('spec week')

              this.clientEvents = response.schedule?.indiv
              let categories = [];
              for (let item of this.clientEvents) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.specialist_id
                  })
                }
              }
              this.categories = categories;

              if(this.specialist_main && this.specialist_main.id){
                this.indivLessonFilter.specialist.push(this.specialist_main.id)
                this.dialogButton_indiv = true
                this.filterEvents(this.indivLessonFilter)
                ////////console.log(this.specialist_main)
              }

            } else if(this.toggle_category === 2){
              ////////console.log('aga')
              if (this.toggle_date === 1 && this.start && this.end) {
                ////////console.log('aga1')
                this.type = 'week'
                this.$store.dispatch(scheduleActionTypes.getSchedule, {
                  start_date: this.start.date,
                  end_date: this.end.date,
                  service_id: this.service ? this.service.service_id : null,
                  service_specialist: this.specialist_main ? this.specialist_main : null
                }).then((response) => {
                  this.clientEvents = response.schedule?.indiv
                })
              } else {

              }
            } else {
              for (let item of response.schedule?.indiv) {
                item.category = item.room_name
              }
              this.clientEvents = response.schedule?.indiv
              this.$store.dispatch(lessonActionTypes.getRoomList, {
                for_lesson: true
              })
                  .then((response) => {
                    if (response.success) {
                      let categories = [];
                      for (let item of response.room) {
                        if(categories.indexOf(item.name) === -1) {
                          categories.push(item.name)
                        }
                      }
                      this.categories = categories;
                    }
                  });
            }

          })
        } 

        // this.$store.dispatch(scheduleActionTypes.getSchedule, {
        //   start_date: s_start_date,
        //   end_date: s_end_date,
        //   service_id: this.service ? this.service.service_id : null,
        //   service_specialist: this.specialist_main ? this.specialist_main : null
        // }).then((response) => {
        //   if (response.success) {
        //     ////////console.log(this.toggle_category)
            

        //     //this.clientEvents = response.schedule?.indiv

        //     if (this.toggle_category === 0) {

        //       if(this.service && this.service.service_id){

        //         ////////console.log(this.specialist_list_def)

        //         if(this.specialist_list_def && this.specialist_list_def.length > 0){
        //           this.clientEvents = response.schedule?.indiv.filter((item) => this.specialist_list_def.includes(item.specialist_id));
        //         } else {
        //           this.clientEvents = response.schedule?.indiv
        //         }

        //       } else {
        //         this.clientEvents = response.schedule?.indiv
        //       }
              
        //       let categories = [];
        //       for (let item of this.clientEvents) {
        //         let searchObject = categories.find((category) => category.text === item.category);
        //         if(searchObject === undefined) {
        //           categories.push({
        //             text: item.category,
        //             value: item.specialist_id
        //           })
        //         }
        //       }
        //       this.categories = categories;

        //       if(this.specialist_main && this.specialist_main.id){
        //         this.indivLessonFilter.specialist.push(this.specialist_main.id)
        //         this.dialogButton_indiv = true
        //         //this.filterEvents(this.indivLessonFilter)
        //         ////////console.log(this.specialist_main)
        //       }

        //     } else if(this.toggle_category === 2){
        //       ////////console.log('aga')
        //       if (this.toggle_date === 1 && this.start && this.end) {
        //         ////////console.log('aga1')
        //         this.type = 'week'
        //         this.$store.dispatch(scheduleActionTypes.getSchedule, {
        //           start_date: this.start.date,
        //           end_date: this.end.date,
        //           service_id: this.service ? this.service.service_id : null,
        //           service_specialist: this.specialist_main ? this.specialist_main : null
        //         }).then((response) => {
        //           this.events = response.schedule?.indiv
        //         })
        //       } else {

        //       }
        //     } else {
        //       for (let item of response.schedule?.indiv) {
        //         item.category = item.room_name
        //       }
        //       this.clientEvents = response.schedule?.indiv
        //       this.$store.dispatch(lessonActionTypes.getRoomList, {
        //         for_lesson: true
        //       })
        //           .then((response) => {
        //             if (response.success) {
        //               let categories = [];
        //               for (let item of response.room) {
        //                 if(categories.indexOf(item.name) === -1) {
        //                   categories.push(item.name)
        //                 }
        //               }
        //               this.categories = categories;
        //             }
        //           });
        //     }

        //     // this.$store.dispatch(scheduleActionTypes.getScheduleDuty, {
        //     //         start_date: s_start_date,
        //     //         end_date: s_end_date
        //     //       }).then((response) => {
        //     //         this.dutyEvents = response.duty;
        //     //       })

        //   }
        // })



      }
      if (this.schedule_tab === 2) {
        ////////console.log('GHHHHH333333')
        setItem('tog-cat', 2)

        if (this.$refs.allFilterForm) {
          this.$refs.allFilterForm.reset();
          this.selected_all.length = 0;
          this.dialogButton_all = false;
          this.dialogFiler_all = false;
        }
          let s_start_date = this.date
          let s_end_date = this.date
          if (this.toggle_date === 0) {
          s_start_date = this.dateTable
          s_end_date = this.dateTable
          }
          if (this.toggle_date === 1 && this.start && this.end) {
          s_start_date = this.start.date
          s_end_date = this.end.date
          }

          if(this.service && this.service.service_id){

              this.$store.dispatch(lessonActionTypes.getSpecialistList, {
                client_id: this.client_id,
                service_id: this.service.service_id
              }).then((resp) => {
                if(resp && resp.specialist){
                  for(let i = 0; i < resp.specialist.length; i++) {
                    this.specialist_list_def.push(resp.specialist[i].id) 
                  }
                }
                
              });
            }

            if (this.toggle_date === 0) {
          this.type = 'day'
          this.$store.dispatch(scheduleActionTypes.getSchedule, {
            start_date: this.dateTable,
            end_date: this.dateTable,
            service_id: this.service ? this.service.service_id : null,
            service_specialist: this.specialist_main ? this.specialist_main : null
          }).then((response) => {

            if (this.toggle_category_all === 0) {
              this.allEvents = response.schedule?.all
              ////////console.log(this.categories)
              this.categories = []
              let categories = [];
              for (let item of this.allEvents) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.specialist_id
                  })
                  this.categories.push({
                    text: item.category,
                    value: item.specialist_id
                  })
                }
              }

              ////////console.log(categories)

              this.categoriesAllEvents = categories;

              if(this.specialist_main && this.specialist_main.id){
                this.allLessonFilter.specialist.push(this.specialist_main.id)
                this.dialogButton_indiv = true
                this.filterEvents(this.allLessonFilter)
                ////////console.log(this.specialist_main)
              }

            } else if(this.toggle_category_all === 2){
              ////////console.log('aga')
              if (this.toggle_date === 1 && this.start && this.end) {
                ////////console.log('aga1')
                this.type = 'week'
                this.$store.dispatch(scheduleActionTypes.getSchedule, {
                  start_date: this.start.date,
                  end_date: this.end.date,
                  service_id: this.service ? this.service.service_id : null,
                  service_specialist: this.specialist_main ? this.specialist_main : null
                }).then((response) => {
                  this.allEvents = response.schedule?.all
                })
              } else {

              }
            } else {
              for (let item of response.schedule?.all) {
                item.category = item.room_name
              }
              this.allEvents = response.schedule?.all
              this.$store.dispatch(lessonActionTypes.getRoomList, {
                for_lesson: true
              })
                  .then((response) => {
                    if (response.success) {
                      this.categories = [];
                      let categories = [];
                      for (let item of response.room) {
                        if(categories.indexOf(item.name) === -1) {
                          categories.push(item.name)
                        }
                      }
                      this.categoriesAllEvents = categories;
                    }
                  });
            }

         

          })
        }
       if (this.toggle_date === 1 && this.start && this.end) {

             ////console.log('week222')
               this.dialogDate = false
              this.type_all = 'week';
              this.dialogDate_all = false;
              this.type = 'week'
      
          this.type = 'week'
          this.$store.dispatch(scheduleActionTypes.getSchedule, {
            start_date: this.start.date,
            end_date: this.end.date,
            service_id: this.service ? this.service.service_id : null,
            service_specialist: this.specialist_main ? this.specialist_main : null
          }).then((response) => {

            if (this.toggle_category === 0) {

              ////console.log('spec week')

              this.allEvents = response.schedule?.all
              let categories = [];
              for (let item of this.allEvents) {
                let searchObject = categories.find((category) => category.text === item.category);
                if(searchObject === undefined) {
                  categories.push({
                    text: item.category,
                    value: item.specialist_id
                  })
                }
              }
              this.categoriesAllEvents = categories;

              if(this.specialist_main && this.specialist_main.id){
                this.allLessonFilter.specialist.push(this.specialist_main.id)
                this.dialogButton_indiv = true
                this.filterEvents(this.allLessonFilter)
                ////////console.log(this.specialist_main)
              }

            } else if(this.toggle_category === 2){
              ////////console.log('aga')
              if (this.toggle_date === 1 && this.start && this.end) {
                ////////console.log('aga1')
                this.type = 'week'
                this.$store.dispatch(scheduleActionTypes.getSchedule, {
                  start_date: this.start.date,
                  end_date: this.end.date,
                  service_id: this.service ? this.service.service_id : null,
                  service_specialist: this.specialist_main ? this.specialist_main : null
                }).then((response) => {
                  this.allEvents = response.schedule?.all
                })
              } else {

              }
            } else {
              for (let item of response.schedule?.all) {
                item.category = item.room_name
              }
              this.allEvents = response.schedule?.all
              this.$store.dispatch(lessonActionTypes.getRoomList, {
                for_lesson: true
              })
                  .then((response) => {
                    if (response.success) {
                      let categories = [];
                      for (let item of response.room) {
                        if(categories.indexOf(item.name) === -1) {
                          categories.push(item.name)
                        }
                      }
                      this.categoriesAllEvents = categories;
                    }
                  });
            }

          })
        } 

          // this.$store.dispatch(scheduleActionTypes.getSchedule, {
          //   start_date: this.date_all,
          //   end_date: this.date_all,
          //   service_id: this.service ? this.service.service_id : null,
          //   service_specialist: this.specialist_main ? this.specialist_main : null
          // }).then((response) => {
          //   if (response.success) {
          //     if (this.toggle_category_all === 0) {
          //       this.allEvents = response.schedule?.all
          //       let categories = [];
          //       for (let item of this.allEvents) {
          //         let searchObject = categories.find((category) => category.text === item.category);
          //         if(searchObject === undefined) {
          //           categories.push({
          //             text: item.category,
          //             value: item.specialist_id
          //           })
          //         }
          //       }
          //       this.categoriesAllEvents = categories;
          //       // this.$store.dispatch(scheduleActionTypes.getScheduleDuty, {
          //       //   start_date: this.date_all,
          //       //   end_date: this.date_all
          //       // }).then((response) => {
          //       //   this.dutyEvents = response.duty;
          //       // })
          //     } else {
          //       for (let item of response.schedule?.all) {
          //         item.category = item.room_name
          //       }
          //       this.allEvents = response.schedule?.all
          //       this.$store.dispatch(lessonActionTypes.getRoomList, {
          //         for_lesson: true
          //       })
          //           .then((response) => {
          //             if (response.success) {
          //               let categories = [];
          //               for (let item of response.room) {
          //                 if(categories.indexOf(item.name) === -1) {
          //                   categories.push(item.name)
          //                 }
          //               }
          //               this.categoriesAllEvents = categories;
          //             }
          //           });
          //     }
          //   }
          // })


      }

      // if(this.clientEvents_def_def.length === 0){
      // ////console.log('set ind def def')

      //   this.clientEvents_def_def = this.clientEvents

      // }

      // if(this.events_def_def.length === 0){
      //   ////console.log('set group def def')

      //   this.events_def_def = this.events

      // }

      // if(this.allEvents_def_def.length === 0){
      //   ////console.log('set all def def')

      //   this.allEvents_def_def = this.allEvents

      // }

      ////console.log('togle type')
    },
    dateTable() {
      ////console.log('strel')
      if (this.toggle_date === 0) {
        ////////console.log('next date')
        ////////console.log(this.toggle_category)
        this.$store.dispatch(scheduleActionTypes.getSchedule, {
          start_date: this.dateTable,
          end_date: this.dateTable,
          service_id: this.service ? this.service.service_id : null,
          service_specialist: this.specialist_main ? this.specialist_main : null
        }).then((response) => {
          //this.events = response.schedule?.group
          //this.clientEvents = response.schedule?.indiv

          if (this.schedule_tab === 0) {

            ////////console.log('group')
            if (response.success) {


              if (this.toggle_category_all === 0) {

                ////////console.log('sotrudniki')

                this.clientEvents = response.schedule?.group
                this.events = response.schedule?.group
                let categories = [];
                for (let item of this.clientEvents) {
                  let searchObject = categories.find((category) => category.text === item.category);
                  if(searchObject === undefined) {
                    categories.push({
                      text: item.category,
                      value: item.specialist_id
                    })
                  }
                }
                this.categories = categories;
              } else {
                for (let item of response.schedule?.group) {
                  item.category = item.room_name
                }
                this.clientEvents = response.schedule?.group
                this.events = response.schedule?.group
                this.$store.dispatch(lessonActionTypes.getRoomList, {
                  for_lesson: true
                })
                    .then((response) => {
                      if (response.success) {
                        let categories = [];
                        for (let item of response.room) {
                          if(categories.indexOf(item.name) === -1) {
                            categories.push(item.name)
                          }
                        }
                        this.categories = categories;
                      }
                    });
              }


              this.events_def = this.events
              this.filterHistory()

              // this.$store.dispatch(scheduleActionTypes.getScheduleDuty, {
              //   start_date: this.dateTable,
              //   end_date: this.dateTable
              //     }).then((response) => {
              //       this.dutyEvents = response.duty;
              //     })
          }
          } else if(this.schedule_tab === 1) {
            if (response.success) {
              if (this.toggle_category === 0) {
                ////////console.log('dadsda11111')
                this.clientEvents = []
                this.clientEvents = response.schedule?.indiv
                let categories = [];
                for (let item of this.clientEvents) {
                  let searchObject = categories.find((category) => category.text === item.category);
                  if(searchObject === undefined) {
                    categories.push({
                      text: item.category,
                      value: item.specialist_id
                    })
                  }
                }
                this.categories = categories;
                ////////console.log(this.categories)
              } else {
                for (let item of response.schedule?.indiv) {
                  item.category = item.room_name
                }
                this.clientEvents = response.schedule?.indiv
                this.$store.dispatch(lessonActionTypes.getRoomList, {
                  for_lesson: true
                })
                    .then((response) => {
                      if (response.success) {
                        let categories = [];
                        for (let item of response.room) {
                          if(categories.indexOf(item.name) === -1) {
                            categories.push(item.name)
                          }
                        }
                        this.categories = categories;
                      }
                    });
              }

              this.clientEvents_def = this.clientEvents
              this.filterHistory()
            }
          } else {
              if (response.success) {
                if (this.toggle_category_all === 0) {
                  ////console.log('aaaa')
                  this.allEvents = response.schedule?.all
                  this.events = response.schedule?.group
                  let categoriesAll = [];
                  let categories = [];
                  for (let item of this.allEvents) {
                    let searchObject = categoriesAll.find((category) => category.text === item.category);
                    if(searchObject === undefined) {
                      categoriesAll.push({
                        text: item.category,
                        value: item.specialist_id
                      })
                    }
                  }
                  for (let item of this.events) {
                    let searchObject = categories.find((category) => category.text === item.category);
                    if(searchObject === undefined) {
                      categories.push({
                        text: item.category,
                        value: item.specialist_id
                      })
                    }
                  }
                  this.categoriesAllEvents = categoriesAll;
                  this.categories = categories;

                  ////console.log('aaaa')
                  ////console.log(this.allEvents)
                  ////console.log(this.categoriesAllEvents)
                  // this.$store.dispatch(scheduleActionTypes.getScheduleDuty, {
                  //   start_date: this.date_all,
                  //   end_date: this.date_all
                  // }).then((response) => {
                  //   this.dutyEvents = response.duty;
                  // })
                } else {
                  for (let item of response.schedule?.all) {
                    item.category = item.room_name
                  }
                  this.allEvents = response.schedule?.all
                  this.events = response.schedule?.group
                  this.$store.dispatch(lessonActionTypes.getRoomList, {
                    for_lesson: true
                  })
                      .then((response) => {
                        if (response.success) {
                          let categories = [];
                          let categoriesAll = [];
                          for (let item of response.room) {
                            if(categoriesAll.indexOf(item.name) === -1) {
                              categoriesAll.push(item.name)
                            }
                          }
                          for (let item of response.room) {
                            if(categories.indexOf(item.name) === -1) {
                              categories.push(item.name)
                            }
                          }
                          this.categoriesAllEvents = categoriesAll;
                          this.categories = categories;
                        }
                      });
                }

                this.allEvents_def = this.allEvents
                this.filterHistory()
            }
          }
        })

        ////console.log('togle date')
      }
      if (this.toggle_date === 1) {
        ////////console.log('wekioiiiii')
      }
    },
    weeklyCalendar(){
      ////////console.log('changeweeekly')
    },
    toggle_date() {
      ////console.log('dateeee')
      ////////console.log(this.toggle_date)
      if (this.toggle_date === 0) {
        this.type = 'day'
        this.$store.dispatch(scheduleActionTypes.getSchedule, {
          start_date: this.dateTable,
          end_date: this.dateTable,
          service_id: this.service ? this.service.service_id : null
        }).then((response) => {
          if (this.schedule_tab === 0) {
            if (response.success) {
              if (this.toggle_category_all === 0) {
                //this.clientEvents = response.schedule?.group
                this.events = response.schedule?.group
                let categories = [];
                for (let item of this.events) {
                  let searchObject = categories.find((category) => category.text === item.category);
                  if(searchObject === undefined) {
                    categories.push({
                      text: item.category,
                      value: item.specialist_id
                    })
                  }
                }
                this.categories = categories;
              } else {
                for (let item of response.schedule?.group) {
                  item.category = item.room_name
                }
                //this.clientEvents = response.schedule?.group
                this.events = response.schedule?.group
                this.$store.dispatch(lessonActionTypes.getRoomList, {
                  for_lesson: true
                })
                    .then((response) => {
                      if (response.success) {
                        let categories = [];
                        for (let item of response.room) {
                          if(categories.indexOf(item.name) === -1) {
                            categories.push(item.name)
                          }
                        }
                        this.categories = categories;
                      }
                    });
              }

              this.events_def = this.events
              this.filterHistory()
          }
          } else if(this.schedule_tab === 1) {
            if (response.success) {
              if (this.toggle_category === 0) {
                this.clientEvents = response.schedule?.indiv
                let categories = [];
                for (let item of this.clientEvents) {
                  let searchObject = categories.find((category) => category.text === item.category);
                  if(searchObject === undefined) {
                    categories.push({
                      text: item.category,
                      value: item.specialist_id
                    })
                  }
                }
                this.categories = categories;
              } else {
                for (let item of response.schedule?.indiv) {
                  item.category = item.room_name
                }
                this.clientEvents = response.schedule?.indiv
                this.$store.dispatch(lessonActionTypes.getRoomList, {
                  for_lesson: true
                })
                    .then((response) => {
                      if (response.success) {
                        let categories = [];
                        for (let item of response.room) {
                          if(categories.indexOf(item.name) === -1) {
                            categories.push(item.name)
                          }
                        }
                        this.categories = categories;
                      }
                    });
              }

              this.clientEvents_def = this.clientEvents
              this.filterHistory()
            }
          } else {
              if (response.success) {
                if (this.toggle_category_all === 0) {
                  this.allEvents = response.schedule?.all
                  this.events = response.schedule?.group
                  let categoriesAll = [];
                  let categories = [];
                  for (let item of this.allEvents) {
                    let searchObject = categoriesAll.find((category) => category.text === item.category);
                    if(searchObject === undefined) {
                      categoriesAll.push({
                        text: item.category,
                        value: item.specialist_id
                      })
                    }
                  }
                  for (let item of this.events) {
                    let searchObject = categories.find((category) => category.text === item.category);
                    if(searchObject === undefined) {
                      categories.push({
                        text: item.category,
                        value: item.specialist_id
                      })
                    }
                  }
                  this.categoriesAllEvents = categories;
                  this.categories = categories;
                  // this.$store.dispatch(scheduleActionTypes.getScheduleDuty, {
                  //   start_date: this.date_all,
                  //   end_date: this.date_all
                  // }).then((response) => {
                  //   this.dutyEvents = response.duty;
                  // })
                } else {
                  for (let item of response.schedule?.all) {
                    item.category = item.room_name
                  }
                  this.allEvents = response.schedule?.all
                  this.events = response.schedule?.group
                  this.$store.dispatch(lessonActionTypes.getRoomList, {
                    for_lesson: true
                  })
                      .then((response) => {
                        if (response.success) {
                          let categories = [];
                          let categoriesAll = [];
                          for (let item of response.room) {
                            if(categoriesAll.indexOf(item.name) === -1) {
                              categoriesAll.push(item.name)
                            }
                          }
                          for (let item of response.room) {
                            if(categories.indexOf(item.name) === -1) {
                              categories.push(item.name)
                            }
                          }
                          this.categoriesAllEvents = categoriesAll;
                          this.categories = categories;
                        }
                      });
                }

                this.allEvents_def = this.allEvents
                this.filterHistory()
            }
          }
          
        })
      }
      if (this.toggle_date === 1) {

        this.range_updated = false
        ////////console.log('weeerrrrk')

        let s_start_date = this.date
          let s_end_date = this.date
        if (this.toggle_date === 0) {
         s_start_date = this.dateTable
         s_end_date = this.dateTable
        }
        if (this.toggle_date === 1 && this.start && this.end) {
         s_start_date = this.start.date
         s_end_date = this.end.date
        }
        this.dialogDate = false
        this.type_all = 'week';
        this.dialogDate_all = false;
        this.type = 'week'

        ////////console.log(this.dateTable)
        ////////console.log(this.start.date)
        ////////console.log(this.end.date)

        if(this.type = 'week') {
          // this.start.date = '2025-03-24'
          // this.end.date = '2025-03-30'
        }

        this.$store.dispatch(scheduleActionTypes.getSchedule, {
          start_date: this.start.date,
          end_date: this.end.date,
          service_id: this.service ? this.service.service_id : null,
          service_specialist: this.specialist_main ? this.specialist_main : null
        }).then((response) => {
          if (this.schedule_tab === 0) {
              if (response.success) {
                if (this.toggle_category_all === 0) {
                  this.events = response.schedule?.group
                  let categories = [];
                  for (let item of this.events) {
                    let searchObject = categories.find((category) => category.text === item.category);
                    if(searchObject === undefined) {
                      categories.push({
                        text: item.category,
                        value: item.specialist_id
                      })
                    }
                  }
                  this.categories = categories;
                } else {
                  for (let item of response.schedule?.group) {
                    item.category = item.room_name
                  }
                  this.events = response.schedule?.group
                  this.$store.dispatch(lessonActionTypes.getRoomList, {
                    for_lesson: true
                  })
                      .then((response) => {
                        if (response.success) {
                          let categories = [];
                          for (let item of response.room) {
                            if(categories.indexOf(item.name) === -1) {
                              categories.push(item.name)
                            }
                          }
                          this.categories = categories;
                        }
                      });
                }

          //       this.$store.dispatch(scheduleActionTypes.getScheduleDuty, {
          //         start_date: s_start_date,
          // end_date: s_end_date
          //         }).then((response) => {
          //           this.dutyEvents = response.duty;
          //         })
            }
          } else if(this.schedule_tab === 1) {
            if (response.success) {
              if (this.toggle_category === 0) {
                this.clientEvents = response.schedule?.indiv
                let categories = [];
                for (let item of this.clientEvents) {
                  let searchObject = categories.find((category) => category.text === item.category);
                  if(searchObject === undefined) {
                    categories.push({
                      text: item.category,
                      value: item.specialist_id
                    })
                  }
                }
                this.categories = categories;
              } else {
                for (let item of response.schedule?.indiv) {
                  item.category = item.room_name
                }
                this.clientEvents = response.schedule?.indiv
                this.$store.dispatch(lessonActionTypes.getRoomList, {
                  for_lesson: true
                })
                    .then((response) => {
                      if (response.success) {
                        let categories = [];
                        for (let item of response.room) {
                          if(categories.indexOf(item.name) === -1) {
                            categories.push(item.name)
                          }
                        }
                        this.categories = categories;
                      }
                    });
              }

          //                     this.$store.dispatch(scheduleActionTypes.getScheduleDuty, {
          //         start_date: s_start_date,
          // end_date: s_end_date
          //         }).then((response) => {
          //           this.dutyEvents = response.duty;
          //         })
            }
          } else {
            if (response.success) {
                if (this.toggle_category_all === 0) {
                  this.allEvents = response.schedule?.all
                  let categories = [];
                  for (let item of this.allEvents) {
                    let searchObject = categories.find((category) => category.text === item.category);
                    if(searchObject === undefined) {
                      categories.push({
                        text: item.category,
                        value: item.specialist_id
                      })
                    }
                  }
                  this.categoriesAllEvents = categories;
                  // this.$store.dispatch(scheduleActionTypes.getScheduleDuty, {
                  //   start_date: this.date_all,
                  //   end_date: this.date_all
                  // }).then((response) => {
                  //   this.dutyEvents = response.duty;
                  // })
                } else {
                  for (let item of response.schedule?.all) {
                    item.category = item.room_name
                  }
                  this.allEvents = response.schedule?.all
                  this.$store.dispatch(lessonActionTypes.getRoomList, {
                    for_lesson: true
                  })
                      .then((response) => {
                        if (response.success) {
                          let categories = [];
                          for (let item of response.room) {
                            if(categories.indexOf(item.name) === -1) {
                              categories.push(item.name)
                            }
                          }
                          this.categoriesAllEvents = categories;
                        }
                      });
                }
            }
          }
        })
      }
    }
  }
}
</script>

<style scoped>

.custom__calendar {
  overflow-y: hidden;
}
.duty-interval {
  background-color: #DBE9FF;
  height: 82px;
}
.event-time {
  font-family: 'Circe';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  color: #000;
}
.event-count {
  padding: 2px 4px;
  background: #1A1A1A;
  border-radius: 2px;
  color: #fff;
}
.event-name {
  padding-top: 10px;
  font-family: 'Circe';
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: 16px;
  color: #000;
}
.event-location {
  padding-top: 4px;
  font-family: 'Circe';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  color: #000;
}
.range-week {
  display: inline-block;
  margin-left: 12px;
  font-family: 'Circe';
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: #629F33;
}
.custom__button {
  width: 121px !important;
  height: 38px;
  display: flex;
  gap: 4px;
  padding: 5px 10px;
  position: relative;
  box-sizing: content-box;
  align-items: center;
  flex-shrink: 0;
  border-radius: 12px !important;
  margin-top: 0 !important;
  justify-content: center;
  background-color: #F1F1F1 !important;
  font-size: 16px;
  font-weight: 700;
  color: #1A1A1A!important;
}
.custom__date-button {
  width: 180px;
  height: 23px;
  display: flex;
  padding: 7px;
  max-width: 180px;
  position: relative;
  box-sizing: content-box;
  align-items: center;
  flex-shrink: 0;
  margin-right: 0;
  border-radius: 12px;
  margin-bottom: 0;
  justify-content: center;
  background-color: var(--dl-color-default-primarysuccess) !important;
  font-size: 16px;
  line-height: 24px;
  color: #fff!important;
}
.custom__select.v-select--is-menu-active {
  outline: 4px solid #E0ECD6;
}

.theme--light.v-btn.v-btn--has-bg {
  background-color: #fff;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  text-transform: none;
}
.theme--light.v-btn--active:hover::before, .theme--light.v-btn--active::before {
  opacity: 0!important;
}
</style>
<style>
   .ccustom_x {
  transform: rotateX(180deg) !important;
  overflow-x: auto !important;
  padding-bottom: 60px;
}


.ccustom_x > div { 
  transform: rotateX(-180deg) !important;
}

.ccustom_x > .v-calendar-daily__head { 
  transform: rotateX(-180deg) !important;
  position: absolute !important;
    bottom: 0px !important;
    top:unset !important;
}
</style>